<template>
    <div id="app">

        <vs-row vs-type="flex" vs-justify="space-between" vs-w="12">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-lg="3"  vs-xs="12">
                <vs-button style="margin-right: 15px;" v-if="therapist_allowed == true" @click="newEvent" color="primary" type="filled">+ Novo</vs-button>
                <vs-button radius icon="refresh" @click="refresh" color="primary" type="filled"></vs-button>
            </vs-col>
            <vs-col class="custom1" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="9"  vs-xs="12">
                <datepicker placeholder="Selecionar Data" :highlighted="highlighted" v-model="jumpDate" @closed="closeTimePicker" :language="ptBR"></datepicker>
                &nbsp;&nbsp;

                <vs-button class="bt1_back" v-on:click="move_days(-1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-left">
                </vs-button>
                &nbsp;<h3>{{calendarDate}}&nbsp;</h3>
                <vs-button class="bt1_back" v-on:click="move_days(1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-right">
                </vs-button>
            </vs-col>
        </vs-row>

        <br/><br/><br/>

        <vx-card v-if="resources.length == 0 || roomsConstant.length == 0">
            <div class="text-center">
                Spa não disponível para marcações.
            </div>
        </vx-card>

        <div v-show="resources.length > 0 && roomsConstant.length > 0">
            <DayPilotScheduler id="dp" :config="config" ref="scheduler" />
            <br/>
            <div class="legenda">
                <h6>{{ $t("scheduleLegend")}}</h6>
                <br/>
                <vs-row class="mr-5" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in roomsConstant" vs-type="inline" vs-justify="left" >
                    <vs-radio :color="item.color"> {{item.name}}</vs-radio>
                </vs-row>
            </div>
        </div>


        <vs-popup :active.sync="showModal" :title="title" @close="closepop" id="popup-marcacoes" fullscreen>
            <form-wizard
            color="rgba(var(--vs-primary), 1)"
            errorColor="rgba(var(--vs-danger), 1)"
            :title="null"
            :subtitle="null"
            :start-index="0"
            finishButtonText="Confirmar"
            back-button-text="Voltar"
            next-button-text="Próximo"
            shape="circle"
            ref="formwizard"
            @on-complete="addEventSchedule"
            @on-change="formWizardTabChange"
            >

                <tab-content title="Evento" class="mb-5" icon="feather icon-calendar" :before-change="validateStep1" >
                    <form data-vv-scope="step-1">
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Spa</h5>
                            </vs-col>
                            <vs-col vs-type="inline" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <vs-input class="selectWidth360" v-model="spa_nome" disabled/>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Evento <span v-if="twoEvent">1</span></h5>
                            </vs-col>

                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected.category_id"
                                    name="events_selected"
                                    autocomplete
                                    id="rowSelected-category_id"
                                    ref="rowSelected_category_id"
                                    :clearable="false"
                                    :options="categoriesEventsList"
                                    label="name"
                                    placeholder="---"
                                    v-validate="'required'"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.category_id"> Campo Obrigatório</span>
                            </vs-col>

                            <vs-col class="second-select mt-5" vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12" vs-offset="3">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected.event_id"
                                    name="events_selected"
                                    autocomplete
                                    id="rowSelected-event_id"
                                    ref="rowSelected_event_id"
                                    :clearable="false"
                                    :options="(spaEvents.length > 0 ? eventOptionsFirst() : [])"
                                    label="name"
                                    placeholder="---"
                                    v-validate="'required'"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                                <vs-button class="ml-5" radius v-if="rowSelected.event_id && !twoEvent && !displayEdit" icon-pack="feather" icon="icon-plus" @click="activateEvent(2)" color="primary" type="filled"></vs-button>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.event_id"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br v-if="twoEvent"/>
                        <vs-row vs-w="12" v-if="twoEvent">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Evento 2</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected2.category_id"
                                    name="events_selected_second"
                                    autocomplete
                                    id="rowSelected2-category_id"
                                    ref="rowSelected2_category_id"
                                    :clearable="false"
                                    :options="categoriesEventsList"
                                    label="name"
                                    placeholder="---"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.category_id_second"> Campo Obrigatório</span>
                            </vs-col>

                            <vs-col class="second-select mt-5" vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12" vs-offset="3">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected2.event_id"
                                    name="events_selected_second"
                                    autocomplete
                                    id="rowSelected2-event_id"
                                    ref="rowSelected2-event_id"
                                    :clearable="true"
                                    :options="(spaEvents_second.length > 0 ? eventOptionsSecond() : [])"
                                    label="name"
                                    placeholder="---"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                                <vs-button class="ml-5" radius v-if="twoEvent && !thirdEvent && !displayEdit" icon-pack="feather" icon="icon-minus" @click="removeEvent(2)" color="primary" type="filled"></vs-button>
                                <vs-button class="ml-5" radius v-if="rowSelected2.event_id && twoEvent && !thirdEvent && !displayEdit" icon-pack="feather" icon="icon-plus" @click="activateEvent(3)" color="primary" type="filled"></vs-button>
                            </vs-col>

                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.event_id_second"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br v-if="thirdEvent"/>
                        <vs-row vs-w="12" v-if="thirdEvent">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Evento 3</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected3.category_id"
                                    name="events_selected_third"
                                    autocomplete
                                    id="rowSelected3-category_id"
                                    ref="rowSelected3_category_id"
                                    :clearable="false"
                                    :options="categoriesEventsList"
                                    label="name"
                                    placeholder="---"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                            </vs-col>

                            <vs-col class="second-select mt-5" vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12" vs-offset="3">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected3.event_id"
                                    name="events_selected_third"
                                    autocomplete
                                    id="rowSelected3-event_id"
                                    ref="rowSelected3-event_id"
                                    :clearable="true"
                                    :options="(spaEvents_third.length > 0 ? eventOptionsThird() : [])"
                                    label="name"
                                    placeholder="---"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                                <vs-button class="ml-5" radius v-if="twoEvent && thirdEvent && !displayEdit" icon-pack="feather" icon="icon-minus" @click="removeEvent(3)" color="primary" type="filled"></vs-button>
                            </vs-col>

                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.event_id_third"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br v-if="display_price !== ''"/>
                        <vs-row v-if="display_price !== ''" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Preço</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <span >{{ massageFinalValue }}</span>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Sala</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected.room_id"
                                    name="room_selected"
                                    autocomplete
                                    id="rowSelected-room_id"
                                    ref="rowSelected-room_id"
                                    :clearable="true"
                                    :options="(rooms.length > 0 ? rooms : [])"
                                    label="name"
                                    placeholder="---"
                                    v-validate="'required'"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>

                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.room_id"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Terapeuta <span v-if="twoPerson">1</span></h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected.therapist_id"
                                    name="room_selected"
                                    autocomplete
                                    id="rowSelected-therapist_id"
                                    ref="rowSelected-therapist_id"
                                    :clearable="true"
                                    :options="(spaTherapists.length > 0 ? spaTherapists : [])"
                                    label="name"
                                    placeholder="---"
                                    v-validate="'required'"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                                <vs-button class="ml-5" radius v-if="rowSelected.therapist_id && !twoPerson && !displayEdit" icon-pack="feather" icon="icon-user-plus" @click="activatePerson(2)" color="primary" type="filled"></vs-button>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.therapist_id"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" v-if="twoPerson">
                                <h5>Terapeuta 2</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12" v-if="twoPerson">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected2.therapist_id"
                                    name="room_selected_second"
                                    autocomplete
                                    id="rowSelected2-therapist_id"
                                    ref="rowSelected2-therapist_id"
                                    :clearable="true"
                                    :options="(spaTherapists2.length > 0 ? spaTherapists2 : [])"
                                    placeholder="---"
                                    label="name"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                                <vs-button class="ml-5" radius v-if="twoPerson && !thirdPerson && !displayEdit" icon-pack="feather" icon="icon-user-minus" @click="removePerson(2)" color="primary" type="filled"></vs-button>
                                <vs-button class="ml-5" radius v-if="twoPerson && !thirdPerson && !displayEdit" icon-pack="feather" icon="icon-user-plus" @click="activatePerson(3)" color="primary" type="filled"></vs-button>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.therapist_id_second"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" v-if="thirdPerson">
                                <h5>Terapeuta 3</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12" v-if="thirdPerson">
                                <v-select
                                    class="selectWidth360"
                                    v-model="rowSelected3.therapist_id"
                                    name="room_selected_third"
                                    autocomplete
                                    id="rowSelected3-therapist_id"
                                    ref="rowSelected3-therapist_id"
                                    :clearable="true"
                                    :options="(spaTherapists3.length > 0 ? spaTherapists3 : [])"
                                    placeholder="---"
                                    label="name"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                                <vs-button class="ml-5" radius v-if="thirdPerson && !displayEdit" icon-pack="feather" icon="icon-user-minus" @click="removePerson(3)" color="primary" type="filled"></vs-button>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.therapist_id_second"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Data</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <datepicker
                                placeholder="YYYY MM DD"
                                :format="datepickerFormat"
                                :minimumView="'day'"
                                :maximumView="'month'"
                                :disabledDates="disabledDates"
                                v-model="rowSelected.event_date"
                                :inline="true"
                                name="event_date"
                                :language="ptBR"
                                v-validate="'required'"
                                >
                                </datepicker>

                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.event_date"> Campo Obrigatório</span>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Hora Início</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <flat-pickr
                                :config="configdateTimePicker"
                                placeholder="HH:MM"
                                value=""
                                v-model="rowSelected.start_time"
                                name="start_time"
                                v-validate="'required'"
                                :disabled="time_lock()"
                                />
                            </vs-col>
                            <vs-col vs-type="inline" vs-justify="left" vs-align="left" vs-offset="3" vs-lg="3" vs-sm="9" vs-xs="12">
                                <span class="scheduler_errors" v-show="scheduler_errors.start_time">Campo Obrigatório</span>
                                <span class="scheduler_errors" v-show="scheduler_errors.start_time_max">O Horario máximo possível é {{start_time_max}}</span>
                                <span class="scheduler_errors" v-show="scheduler_errors.start_time_max2">O Horario máximo possível é {{start_time_max2}}</span>
                                <span class="scheduler_errors" v-show="scheduler_errors.start_time_max3">O Horario máximo possível é {{start_time_max3}}</span>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12">
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="3" vs-sm="3" vs-xs="12" >
                                <h5>Observações</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <vs-textarea class="selectWidth360" v-if="showNew" v-model="rowSelected.comments" name="comments" height="150" />
                            </vs-col>
                        </vs-row>

                    </form>
                </tab-content>
                <tab-content title="Cliente" class="mb-5 new-tabs" icon="feather icon-user" :before-change="validateStep2" >

                    <form data-vv-scope="step-2">
                        <!-- Selector cliente -->
                        <vs-row vs-w="12" class="mb-10" >
                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12">
                                <h5>Cliente(s)</h5>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                <v-select
                                    class="selectWidth360"
                                    v-model="clientSelectedOption"
                                    name="clientSelect"
                                    autocomplete
                                    id="clientSelect-tab"
                                    :clearable="false"
                                    :options="( clientOptionTab )"
                                    placeholder="---"
                                    label="name"
                                >
                                    <span slot="no-options"> --- </span>
                                </v-select>
                            </vs-col>
                        </vs-row>
                        <!-- /Selector cliente -->

                        <vs-row vs-w="12">
                            <!-- Cliente 1 -->
                            <vs-col v-if="selectedIndex == 0" vs-type="flex" vs-justify="left" vs-align="left" vs-lg="12" vs-sm="12" vs-xs="12" >

                                <vs-tabs alignment="fixed" position="top" v-model="selectedTab" ref="clientTab1" >
                                    <vs-tab label="Pesquisa" icon-pack="feather" icon="icon-search">
                                        <!-- Pesquisa -->
                                        <br/>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nome</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="10" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="rowSelected.search_nome"
                                                    icon-pack="feather"
                                                    icon="icon-user"
                                                    name="search_nome"
                                                />
                                            </vs-col>

                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Data de Nascimento</h5>
                                            </vs-col>

                                            <vs-col vs-type="flex"  vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <datepicker
                                                style="max-width:350px"
                                                class="w-full"
                                                :calendar-class="'calendar_date'"
                                                :format="datepickerFormat"
                                                :initial-view="'year'"
                                                v-model="rowSelected.search_data_nasc"
                                                name="event_date"
                                                :clear-button="true"
                                                :clear-button-icon="'fa fa-times'"
                                                :language="ptBR"
                                                >
                                                </datepicker>
                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nº Identificação Fiscal</h5>
                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected.search_cod_fiscal"
                                                    icon-pack="feather"
                                                    icon="icon-check"
                                                    name="search_cod_fiscal"/>
                                            </vs-col>

                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Email</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected.search_email"
                                                    icon-pack="feather"
                                                    icon="icon-mail"/>
                                            </vs-col>


                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Contacto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected.search_telefone"
                                                    icon-pack="feather"
                                                    icon="icon-smartphone"/>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nº Quarto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    style="max-width:350px"
                                                    v-model="rowSelected.search_quarto"
                                                    icon-pack="feather"
                                                    icon="icon-briefcase"/>
                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="5" vs-xs="12" >
                                                <h5>Nº Reserva</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="5" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    style="max-width:350px"
                                                    v-model="rowSelected.search_reserva"
                                                    icon-pack="feather"
                                                    icon="icon-book-open"/>
                                            </vs-col>

                                        </vs-row>

                                        <br/>
                                        <br/>
                                        <vs-row vs-w="12" vs-justify="left">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="12" vs-sm="12" vs-xs="12" >
                                                <vs-button @click="searchContact(1)" class="mb-2">Pesquisar</vs-button>
                                            </vs-col>
                                        </vs-row>
                                        <br/>

                                        <vs-table
                                        pagination
                                        max-items="5"
                                        noDataText="Não foram encontrados registos"
                                        :data="clientSearchResult"
                                        @selected="handleScheduleEvent"
                                        v-model="rowSelected.selectedContact"
                                        >
                                            <template slot="header">
                                                <h3>Lista de Clientes</h3>
                                            </template>

                                            <template slot="thead">
                                                <vs-th>
                                                </vs-th>
                                                <vs-th>
                                                    Nº Reserva
                                                </vs-th>
                                                <vs-th>
                                                    Estado Reserva
                                                </vs-th>
                                                <vs-th>
                                                    Nome
                                                </vs-th>
                                                <vs-th>
                                                    País
                                                </vs-th>
                                                <vs-th>
                                                    Data de Nascimento
                                                </vs-th>
                                                <vs-th>
                                                    Email
                                                </vs-th>
                                                <vs-th>
                                                    Contacto
                                                </vs-th>
                                                <vs-th>
                                                    Cartão de Fidelização
                                                </vs-th>
                                            </template>

                                            <template slot-scope="{data}">
                                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                                    <vs-td :data="data[indextr].reservation_id">
                                                        <input type="hidden" :value="data[indextr].reservation_id" name="reservation_id" />
                                                        <input type="hidden" :value="data[indextr].reservation_status" name="reservation_status" />
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].reservation_id">
                                                    {{
                                                        data[indextr] && data[indextr].reservation_id
                                                        ? data[indextr].reservation_id
                                                        : '---'
                                                    }}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].reservation_status && reservation_status[data[indextr].reservation_status]">
                                                    {{
                                                        data[indextr].reservation_status &&
                                                        reservation_status[data[indextr].reservation_status]
                                                        ? reservation_status[data[indextr].reservation_status]
                                                        : '---'
                                                    }}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].nome">
                                                        {{data[indextr].nome}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].nacionalidade">
                                                        {{data[indextr].nacionalidade}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].data_nascimento">
                                                        {{data[indextr].data_nascimento}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].email">
                                                        {{data[indextr].email}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].telefone">
                                                        {{data[indextr].telefone}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].card">
                                                        {{data[indextr].card}}
                                                    </vs-td>
                                                </vs-tr>
                                            </template>
                                        </vs-table>
                                        <!-- /Pesquisa -->
                                    </vs-tab>
                                    <vs-tab label="Dados do Cliente" icon-pack="feather" icon="icon-user" class="activeChild">
                                        <!-- Dados do Cliente -->
                                        <br/>
                                        <vs-row vs-w="12" v-show="twoPerson">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Evento/Terapeuta</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <v-select
                                                    class="selectWidth360"
                                                    v-model="rowSelected.evento_terapeuta"
                                                    name="evento_terapeuta"
                                                    autocomplete
                                                    id="rowSelected-evento_terapeuta"
                                                    ref="rowSelected-evento_terapeuta"
                                                    :clearable="true"
                                                    :options="eventos_terapeutas"
                                                    placeholder="---"
                                                    label="label"
                                                >
                                                </v-select>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.evento_terapeuta"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Nome</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <vs-input @keyup="setClientsSelectOptions(0,$event.target.value)" class="selectWidth360" v-model="rowSelected.nome" icon-pack="feather" icon="icon-user" name="nome"
                                                v-validate="'required'" :disabled="showNew && client_if_staff == true || displayEdit" />
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.nome"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="3" >
                                                <h5>Género</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="9">

                                                <vs-radio v-model="rowSelected.cod_sexo" vs-value="1" color="primary"
                                                v-validate="'required'" name="cod_sexo" :disabled="client_if_staff == true" >
                                                    <span>Masculino</span>
                                                </vs-radio>
                                                &nbsp;&nbsp;&nbsp;
                                                <vs-radio v-model="rowSelected.cod_sexo" vs-value="2" color="primary"
                                                v-validate="'required'" name="cod_sexo" :disabled="client_if_staff == true">
                                                Feminimo
                                                </vs-radio>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_sexo"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Data de Nascimento</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12" id="cliente-data_nascimento">

                                                <datepicker
                                                :calendar-class="'calendar_date'"
                                                :format="datepickerFormat"
                                                :initial-view="'year'"
                                                v-model="rowSelected.data_nascimento"
                                                name="event_date"
                                                :disabled="client_if_staff == true"
                                                :clear-button="client_if_staff == true ? false : true"
                                                :clear-button-icon="'fa fa-times'"
                                                 :language="ptBR"
                                                >
                                                </datepicker>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>País</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">

                                                <v-select
                                                    class="selectWidth360"
                                                    v-model="rowSelected.nacionalidade"
                                                    name="nacionalidade"
                                                    autocomplete
                                                    id="rowSelected-nacionalidade"
                                                    ref="rowSelected-nacionalidade"
                                                    :clearable="false"
                                                    :options="countries"
                                                    label="pais"
                                                    v-validate="'required'"
                                                    placeholder="---"
                                                    :disabled="showNew && client_if_staff == true"
                                                >
                                                </v-select>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.nacionalidade"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Nº Identificação Fiscal</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected.cod_fiscal" icon-pack="feather" icon="icon-check"
                                                name="cod_fiscal" :disabled="showNew && client_if_staff == true"/>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_fiscal">Nº de identificação fiscal incorrecto</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_fiscal1">Nº de identificação fiscal já existe</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Contacto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected.telefone" icon-pack="feather" icon="icon-smartphone" name="telefone"
                                                :disabled="showNew && client_if_staff == true"/>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.telefone"> O "Contacto" é obrigatório caso o "Email" não se encontre preenchido</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.telefone1">Já existem fichas de cliente com o contacto inserido.</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Email</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected.email" icon-pack="feather" icon="icon-mail" name="email"
                                                :disabled="showNew && client_if_staff == true"/>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.email"> O "Email" é obrigatório caso o "Contacto" não se encontre preenchido</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.email1">Já existem fichas de cliente com o email inserido.</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.email11">O Email inserido não é válido</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Cartão de Fidelização</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected.selectedContact.card" icon-pack="feather" icon="icon-credit-card" name="card"
                                                disabled/>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <!-- /Dados do Cliente -->
                                    </vs-tab>
                                </vs-tabs>

                            </vs-col>
                            <!-- /Cliente 1 -->

                            <!-- Cliente 2 -->
                            <vs-col v-if="twoPerson && selectedIndex == 1" vs-type="flex" vs-justify="left" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12" >

                                 <vs-tabs alignment="fixed" position="top" v-model="selectedTab2" ref="clientTab2">
                                    <vs-tab label="Pesquisa" icon-pack="feather" icon="icon-search">
                                        <!-- Pesquisa -->
                                        <br/>
                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nome</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="10" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="rowSelected2.search_nome"
                                                    icon-pack="feather"
                                                    icon="icon-user"
                                                    name="search_nome"
                                                />
                                            </vs-col>

                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Data de Nascimento</h5>
                                            </vs-col>

                                            <vs-col vs-type="flex"  vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <datepicker
                                                style="max-width:350px"
                                                class="w-full"
                                                :calendar-class="'calendar_date'"
                                                :format="datepickerFormat"
                                                :initial-view="'year'"
                                                v-model="rowSelected2.search_data_nasc"
                                                name="event_date"
                                                :clear-button="true"
                                                :clear-button-icon="'fa fa-times'"
                                                :language="ptBR"
                                                >
                                                </datepicker>

                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nº Identificação Fiscal</h5>
                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected2.search_cod_fiscal"
                                                    icon-pack="feather"
                                                    icon="icon-check"
                                                    name="search_cod_fiscal"/>
                                            </vs-col>


                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Email</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected2.search_email"
                                                    icon-pack="feather"
                                                    icon="icon-mail"/>
                                            </vs-col>


                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Contacto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected2.search_telefone"
                                                    icon-pack="feather"
                                                    icon="icon-smartphone"/>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nº Quarto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    style="max-width:350px"
                                                    v-model="rowSelected2.search_quarto"
                                                    icon-pack="feather"
                                                    icon="icon-briefcase"/>
                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="5" vs-xs="12" >
                                                <h5>Nº Reserva</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="5" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    style="max-width:350px"
                                                    v-model="rowSelected2.search_reserva"
                                                    icon-pack="feather"
                                                    icon="icon-book-open"/>
                                            </vs-col>

                                        </vs-row>

                                        <br/>
                                        <br/>
                                        <vs-row vs-w="12" vs-justify="left">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="12" vs-sm="12" vs-xs="12" >
                                                <vs-button @click="searchContact(2)" class="mb-2">Pesquisar</vs-button>
                                            </vs-col>
                                        </vs-row>
                                        <br/>

                                        <vs-table
                                        pagination
                                        max-items="5"
                                        noDataText="Não foram encontrados registos"
                                        :data="clientSearchResult2"
                                        @selected="handleScheduleEvent2"
                                        v-model="rowSelected2.selectedContact"
                                        >
                                            <template slot="header">
                                                <h3>Lista de Clientes</h3>
                                            </template>

                                            <template slot="thead">
                                                <vs-th>
                                                </vs-th>
                                                <vs-th>
                                                    Nome
                                                </vs-th>
                                                <vs-th>
                                                    País
                                                </vs-th>
                                                <vs-th>
                                                    Data de Nascimento
                                                </vs-th>
                                                <vs-th>
                                                    Email
                                                </vs-th>
                                                <vs-th>
                                                    Contacto
                                                </vs-th>
                                                <vs-th>
                                                    Cartão de Fidelização
                                                </vs-th>
                                            </template>

                                            <template slot-scope="{data}">
                                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                                    <vs-td :data="data[indextr].reservation_id">
                                                        <input type="hidden" :value="data[indextr].reservation_id" name="reservation_id2" />
                                                        <input type="hidden" :value="data[indextr].reservation_status" name="reservation_status2" />
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].nome">
                                                        {{data[indextr].nome}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].nacionalidade">
                                                        {{data[indextr].nacionalidade}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].data_nascimento">
                                                        {{data[indextr].data_nascimento}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].email">
                                                        {{data[indextr].email}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].telefone">
                                                        {{data[indextr].telefone}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].card">
                                                        {{data[indextr].card}}
                                                    </vs-td>
                                                </vs-tr>
                                            </template>
                                        </vs-table>
                                        <!-- /Pesquisa -->
                                    </vs-tab>

                                    <vs-tab label="Dados do Cliente" icon-pack="feather" icon="icon-user" class="activeChild">
                                        <!-- Dados do Cliente -->
                                        <br/>
                                        <vs-row vs-w="12" v-show="twoPerson || thirdPerson">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Evento/Terapeuta</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <v-select
                                                    class="selectWidth360"
                                                    v-model="rowSelected2.evento_terapeuta"
                                                    name="evento_terapeuta"
                                                    autocomplete
                                                    id="rowSelected2-evento_terapeuta"
                                                    ref="rowSelected2-evento_terapeuta"
                                                    :clearable="true"
                                                    :options="eventos_terapeutas"
                                                    placeholder="---"
                                                    label="label"
                                                >
                                                </v-select>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.evento_terapeuta_second"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Nome</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <vs-input @keyup="setClientsSelectOptions(1,$event.target.value)" class="selectWidth360" v-model="rowSelected2.nome" icon-pack="feather" icon="icon-user" name="nome2"
                                                :disabled="showNew2 && client_if_staff2 == true"/>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.nome2"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="3" >
                                                <h5>Género</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="9">

                                                <vs-radio v-model="rowSelected2.cod_sexo" vs-value="1" color="primary"
                                                name="cod_sexo_second" :disabled="client_if_staff2 == true" >
                                                    <span>Masculino</span>
                                                </vs-radio>
                                                &nbsp;&nbsp;&nbsp;
                                                <vs-radio v-model="rowSelected2.cod_sexo" vs-value="2" color="primary"
                                                name="cod_sexo_second" :disabled="client_if_staff2 == true">
                                                Feminimo
                                                </vs-radio>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_sexo2"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Data de Nascimento</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12" id="cliente-data_nascimento">

                                                <datepicker
                                                :calendar-class="'calendar_date'"
                                                :format="datepickerFormat"
                                                :initial-view="'year'"
                                                v-model="rowSelected2.data_nascimento"
                                                name="event_date2"
                                                :disabled="client_if_staff2 == true"
                                                :clear-button="client_if_staff2 == true ? false : true"
                                                :clear-button-icon="'fa fa-times'"
                                                :language="ptBR"
                                                >
                                                </datepicker>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>País</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">

                                                <v-select
                                                    class="selectWidth360"
                                                    v-model="rowSelected2.nacionalidade"
                                                    name="nacionalidade2"
                                                    autocomplete
                                                    id="rowSelected-nacionalidade"
                                                    ref="rowSelected-nacionalidade"
                                                    :clearable="false"
                                                    :options="countries"
                                                    label="pais"
                                                    placeholder="---"
                                                    :disabled="showNew2 && client_if_staff2 == true"
                                                >
                                                </v-select>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.nacionalidade2"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Nº Identificação Fiscal</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected2.cod_fiscal" icon-pack="feather" icon="icon-check"
                                                name="cod_fiscal2" :disabled="showNew2 && client_if_staff2 == true"/>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_fiscal2">Nº de identificação fiscal incorrecto</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_fiscal12">Nº de identificação fiscal já existe</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Contacto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected2.telefone" icon-pack="feather" icon="icon-smartphone" name="telefone2"
                                                :disabled="showNew2 && client_if_staff2 == true"/>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.telefone2"> O "Contacto" é obrigatório caso o "Email" não se encontre preenchido</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.telefone12">Já existem fichas de cliente com o contacto inserido.</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Email</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected2.email" icon-pack="feather" icon="icon-mail" name="email2"
                                                :disabled="showNew2 && client_if_staff2 == true"/>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.email2"> O "Email" é obrigatório caso o "Contacto" não se encontre preenchido</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.email12">Já existem fichas de cliente com o email inserido.</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Cartão de Fidelização</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <vs-input class="selectWidth360" v-model="rowSelected2.selectedContact.card" icon-pack="feather" icon="icon-credit-card" name="card"
                                                disabled/>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <!-- /Dados do Cliente -->
                                    </vs-tab>
                                </vs-tabs>
                            </vs-col>
                            <!-- /Cliente 2 -->

                            <!-- Cliente 3 -->
                            <vs-col v-if="twoPerson && thirdPerson && selectedIndex == 2" vs-type="flex" vs-justify="left" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12" >

                                <vs-tabs alignment="fixed" position="top" v-model="selectedTab3" ref="clientTab3">
                                    <vs-tab label="Pesquisa" icon-pack="feather" icon="icon-search">
                                        <!-- Pesquisa -->
                                        <br/>
                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nome</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="10" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="rowSelected3.search_nome"
                                                    icon-pack="feather"
                                                    icon="icon-user"
                                                    name="search_nome"
                                                />
                                            </vs-col>

                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Data de Nascimento</h5>
                                            </vs-col>

                                            <vs-col vs-type="flex"  vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <datepicker
                                                style="max-width:350px"
                                                class="w-full"
                                                :calendar-class="'calendar_date'"
                                                :format="datepickerFormat"
                                                :initial-view="'year'"
                                                v-model="rowSelected3.search_data_nasc"
                                                name="event_date"
                                                :clear-button="true"
                                                :clear-button-icon="'fa fa-times'"
                                                :language="ptBR"
                                                >
                                                </datepicker>

                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nº Identificação Fiscal</h5>
                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected3.search_cod_fiscal"
                                                    icon-pack="feather"
                                                    icon="icon-check"
                                                    name="search_cod_fiscal"/>
                                            </vs-col>


                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Email</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected3.search_email"
                                                    icon-pack="feather"
                                                    icon="icon-mail"/>
                                            </vs-col>


                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Contacto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    style="max-width:350px"
                                                    class="w-full"
                                                    v-model="rowSelected3.search_telefone"
                                                    icon-pack="feather"
                                                    icon="icon-smartphone"/>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="12" vs-xs="12" >
                                                <h5>Nº Quarto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="12" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    style="max-width:350px"
                                                    v-model="rowSelected3.search_quarto"
                                                    icon-pack="feather"
                                                    icon="icon-briefcase"/>
                                            </vs-col>

                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="5" vs-xs="12" >
                                                <h5>Nº Reserva</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="4" vs-sm="5" vs-xs="12">
                                                <vs-input
                                                    class="w-full"
                                                    style="max-width:350px"
                                                    v-model="rowSelected3.search_reserva"
                                                    icon-pack="feather"
                                                    icon="icon-book-open"/>
                                            </vs-col>

                                        </vs-row>

                                        <br/>
                                        <br/>
                                        <vs-row vs-w="12" vs-justify="left">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="12" vs-sm="12" vs-xs="12" >
                                                <vs-button @click="searchContact(3)" class="mb-2">Pesquisar</vs-button>
                                            </vs-col>
                                        </vs-row>
                                        <br/>

                                        <vs-table
                                        pagination
                                        max-items="5"
                                        noDataText="Não foram encontrados registos"
                                        :data="clientSearchResult3"
                                        @selected="handleScheduleEvent3"
                                        v-model="rowSelected3.selectedContact"
                                        >
                                            <template slot="header">
                                                <h3>Lista de Clientes</h3>
                                            </template>

                                            <template slot="thead">
                                                <vs-th>
                                                </vs-th>
                                                <vs-th>
                                                    Nome
                                                </vs-th>
                                                <vs-th>
                                                    País
                                                </vs-th>
                                                <vs-th>
                                                    Data de Nascimento
                                                </vs-th>
                                                <vs-th>
                                                    Email
                                                </vs-th>
                                                <vs-th>
                                                    Contacto
                                                </vs-th>
                                                <vs-th>
                                                    Cartão de Fidelização
                                                </vs-th>
                                            </template>

                                            <template slot-scope="{data}">
                                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                                    <vs-td :data="data[indextr].nome">
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].nome">
                                                        {{data[indextr].nome}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].nacionalidade">
                                                        {{data[indextr].nacionalidade}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].data_nascimento">
                                                        {{data[indextr].data_nascimento}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].email">
                                                        {{data[indextr].email}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].telefone">
                                                        {{data[indextr].telefone}}
                                                    </vs-td>

                                                    <vs-td :data="data[indextr].card">
                                                        {{data[indextr].card}}
                                                    </vs-td>
                                                </vs-tr>
                                            </template>
                                        </vs-table>
                                        <!-- /Pesquisa -->
                                    </vs-tab>
                                    <vs-tab label="Dados do Cliente" icon-pack="feather" icon="icon-user" class="activeChild">
                                        <!-- Dados do Cliente -->
                                        <br/>
                                        <vs-row vs-w="12" v-show="thirdPerson">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Evento/Terapeuta</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <v-select
                                                    class="w-full"
                                                    style="min-width:350px"
                                                    v-model="rowSelected3.evento_terapeuta"
                                                    name="evento_terapeuta"
                                                    autocomplete
                                                    id="rowSelected3-evento_terapeuta"
                                                    ref="rowSelected3-evento_terapeuta"
                                                    :clearable="true"
                                                    :options="eventos_terapeutas"
                                                    placeholder="---"
                                                    label="label"
                                                >
                                                </v-select>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.evento_terapeuta_third"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Nome</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <vs-input @keyup="setClientsSelectOptions(2,$event.target.value)" class="selectWidth360" v-model="rowSelected3.nome" icon-pack="feather" icon="icon-user" name="nome2"
                                                :disabled="showNew3 && client_if_staff3 == true"/>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.nome3"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="3" >
                                                <h5>Género</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="9">

                                                <vs-radio v-model="rowSelected3.cod_sexo" vs-value="1" color="primary"
                                                name="cod_sexo_second" :disabled="client_if_staff3 == true" >
                                                    <span>Masculino</span>
                                                </vs-radio>
                                                &nbsp;&nbsp;&nbsp;
                                                <vs-radio v-model="rowSelected3.cod_sexo" vs-value="2" color="primary"
                                                name="cod_sexo_second" :disabled="client_if_staff3 == true">
                                                Feminimo
                                                </vs-radio>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_sexo3"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Data de Nascimento</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12" id="cliente-data_nascimento">

                                                <datepicker
                                                :calendar-class="'calendar_date'"
                                                :format="datepickerFormat"
                                                :initial-view="'year'"
                                                v-model="rowSelected3.data_nascimento"
                                                name="event_date3"
                                                :disabled="client_if_staff3 == true"
                                                :clear-button="client_if_staff3 == true ? false : true"
                                                :clear-button-icon="'fa fa-times'"
                                                :language="ptBR"
                                                >
                                                </datepicker>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>País</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">

                                                <v-select
                                                    class="selectWidth360"
                                                    v-model="rowSelected3.nacionalidade"
                                                    name="nacionalidade3"
                                                    autocomplete
                                                    id="rowSelected3-nacionalidade"
                                                    ref="rowSelected3-nacionalidade"
                                                    :clearable="false"
                                                    :options="countries"
                                                    label="pais"
                                                    placeholder="---"
                                                    :disabled="showNew3 && client_if_staff3 == true"
                                                >
                                                </v-select>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.nacionalidade3"> Campo Obrigatório</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Nº Identificação Fiscal</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected3.cod_fiscal" icon-pack="feather" icon="icon-check"
                                                name="cod_fiscal3" :disabled="showNew3 && client_if_staff3 == true"/>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_fiscal3">Nº de identificação fiscal incorrecto</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.cod_fiscal13">Nº de identificação fiscal já existe</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Contacto</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="6" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected3.telefone" icon-pack="feather" icon="icon-smartphone" name="telefone3"
                                                :disabled="showNew3 && client_if_staff3 == true"/>
                                            </vs-col>
                                            <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.telefone3"> O "Contacto" é obrigatório caso o "Email" não se encontre preenchido</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.telefone13">Já existem fichas de cliente com o contacto inserido.</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Email</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">

                                                <vs-input class="selectWidth360" v-model="rowSelected3.email" icon-pack="feather" icon="icon-mail" name="email2"
                                                :disabled="showNew3 && client_if_staff3 == true"/>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-offset="3" vs-lg="5" vs-sm="9" vs-xs="12">
                                                <span class="scheduler_errors" v-show="scheduler_errors.email3"> O "Email" é obrigatório caso o "Contacto" não se encontre preenchido</span>
                                                <span class="scheduler_errors" v-show="scheduler_errors.email13">Já existem fichas de cliente com o email inserido.</span>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <vs-row vs-w="12">
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12" >
                                                <h5>Cartão de Fidelização</h5>
                                            </vs-col>
                                            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="9" vs-sm="9" vs-xs="12">
                                                <vs-input class="selectWidth360" v-model="rowSelected3.selectedContact.card" icon-pack="feather" icon="icon-credit-card" name="card"
                                                disabled/>
                                            </vs-col>
                                        </vs-row>

                                        <br/>
                                        <!-- /Dados do Cliente -->
                                    </vs-tab>
                                </vs-tabs>
                            </vs-col>
                            <!-- /Cliente 3 -->
                        </vs-row>

                    </form>

                </tab-content>
            </form-wizard>

        </vs-popup>

        <vs-popup :active.sync="showCancelMenu" :title="title" @close="closepop2" >

            <vs-row
                :key="index"
                :value="item.spa_cancel_justification_id"
                :text="item.justification"
                v-for="(item,index) in cancelMenuItems"
                vs-type="flex"
                vs-justify="left">
                <vs-radio
                    v-model="rowcancel.id"
                    :vs-value="JSON.stringify(item.spa_cancel_justification_id)" > {{item.justification}}
                </vs-radio>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;
            </vs-row>

            <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-button @click="cancelEventSchedule()" color="primary" type="filled">Submeter</vs-button>
            </vs-row>
        </vs-popup>

        <vs-popup :active.sync="popupDrag" :title="popupDragTitle" @close="closepop3">
            <vs-row>
                Este evento está associado a outro evento.
                <br>
                <span v-html="popupDragText"></span>
            </vs-row>
            <br>
            <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-button
                    @click="popupDragType == 'edit' ? dragTrigger(2) : cancelEvent(argsEvents.source)"
                    color="primary"
                    type="filled"
                    class="mr-5"
                    v-html="popupDragButton"
                ></vs-button>
                <vs-button
                    @click="closepop3()"
                    color="danger"
                    type="border"
                    class="ml-5"
                >Sair</vs-button>
            </vs-row>
        </vs-popup>

        <vs-popup :active.sync="showChargeRoomPopup" :title="title" @close="closeChargeRoomPopup" >
            <vs-row>
                Pretende efetuar débito ao quarto?
            </vs-row>
            <br>
            <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-button
                    @click="chargeRoom()"
                    color="primary"
                    type="filled"
                    class="mr-5"
                >Debitar</vs-button>
                <vs-button
                    @click="closeChargeRoomPopup()"
                    color="danger"
                    type="border"
                    class="ml-5"
                >Cancelar</vs-button>
            </vs-row>
        </vs-popup>

        <vs-popup :active.sync="showAfterHoursPopup" style="z-index: 99999;" :title="title" @close="closeAfterHoursPopup" ref="after_hours_popup">
            <vs-row>
                Marcação fora de horário de funcionamento, pretende avançar?
            </vs-row>
            <br>
            <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-button
                    @click="scheduleAfterHours()"
                    color="primary"
                    type="filled"
                    class="mr-5"
                >Avançar</vs-button>
                <vs-button
                    @click="closeAfterHoursPopup()"
                    color="danger"
                    type="border"
                    class="ml-5"
                >Cancelar</vs-button>
            </vs-row>
        </vs-popup>

        <vs-popup :active.sync="showPassedEventsPopup" style="z-index: 99999;" :title="title" @close="closePassedEventsPopup" ref="passed_events_popup">
            <vs-row>
                A data para esta marcação já passou, pretende avançar?
            </vs-row>
            <br>
            <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-button
                    @click="schedulePassedEvents()"
                    color="primary"
                    type="filled"
                    class="mr-5"
                >Avançar</vs-button>
                <vs-button
                    @click="closePassedEventsPopup()"
                    color="danger"
                    type="border"
                    class="ml-5"
                >Cancelar</vs-button>
            </vs-row>
        </vs-popup>

    </div>
</template>

<script>
    import {DayPilot, DayPilotScheduler} from 'daypilot-pro-vue'
    import Vue from 'vue'

    import themeConfig from '@/../themeConfig.js';

    import axios from 'axios';

    import Datepicker from 'vuejs-datepicker';
    import {ptBR} from 'vuejs-datepicker/dist/locale';
    import vSelect from 'vue-select';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { FormWizard, TabContent } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    import VueSimpleSuggest from 'vue-simple-suggest';
    import 'vue-simple-suggest/dist/styles.css';

    import moment from 'moment';

    import { Validator } from 'vee-validate';

    const dict = {
        custom: {
            events_selected: {
                required: 'Campo Obrigatório ',
            },
            room_selected: {
                required: 'Campo Obrigatório ',
            },
        }
    };
    Validator.localize('pt', dict);

    export default {
        name: 'Scheduler',
        props: [
        'spaSelected',
        'spaInitial',
        'hotelSelected',
        ],
        data: function() {
            return {
                oldCurrentSpa : this.spaInitial,
                loaded_therapists_events : [],
                highlighted: {
                    dates: [
                      new Date(Date.now())
                    ]
                },
                configdateTimePicker: {
                    enableTime: true,
                    enableSeconds: false,
                    noCalendar: true,
                    time_24hr: true,
                    defaultHour	: '00',
                    minTime: "",
                    maxTime: "",
                },
                profile_chosen: false,
                profile_chosen2: false,
                profile_chosen3: false,
                editEventRequest: false,
                checked: "true",
                jumpDate: '',
                disButtonBack: true,
                displayPickCalendarTop: false,
                loadingEdit: false,
                update: false,
                title: 'Evento',
                name: '',
                displayNew :false,
                displayEdit : false,
                showModal: false,
                showCancelMenu : false,
                showChargeRoomPopup: false,
                showAfterHoursPopup: false,
                showPassedEventsPopup: false,
                saveAfterHoursEvent: false,
                savePassedEvents: false,
                afterHoursEvent: false,
                chargeRoomEvent: false,
                showNew : true,
                showNew2 : true,
                showNew3 : true,
                mode: 'select',
                currentTabIndex: 0,

                startTime: '',
                config : {},

                spa_id: '',
                spa_nome: '',

                rowSelected: {
                    person_id: null,
                    category_id: '',
                    room_id : '',
                    therapist_id : '',
                    start_time : '',
                    end_time : '',
                    search_nome : '',
                    search_telefone : '',
                    search_email : '',
                    search_data_nasc : '',
                    search_cod_fiscal: '',
                    search_reserva : '',
                    search_quarto : '',
                    selectedContact : [],
                    event_date : new DayPilot.Date.today().toString("yyyy-MM-dd"),
                    event_id : '',
                    event_schedule_id: null,
                    nome : '',
                    email : '',
                    data_nascimento : '',
                    nacionalidade : '',
                    cod_nacionalidade : '',
                    telefone : '',
                    cod_fiscal : '',
                    cod_sexo : '',
                    update_contact : false,
                    comments: '',
                    evento_terapeuta: '',
                },
                client_if_staff : false,
                rowSelected2: {
                    person_id: null,
                    category_id: '',
                    room_id : '',
                    therapist_id : '',
                    start_time : '',
                    end_time : '',
                    search_nome : '',
                    search_telefone : '',
                    search_email : '',
                    search_data_nasc : '',
                    search_cod_fiscal: '',
                    search_reserva : '',
                    search_quarto : '',
                    selectedContact : [],
                    event_date : '',
                    event_id : '',
                    event_schedule_id: null,
                    nome : '',
                    email : '',
                    data_nascimento : '',
                    nacionalidade : '',
                    cod_nacionalidade : '',
                    telefone : '',
                    cod_fiscal : '',
                    cod_sexo : '',
                    update_contact : false,
                    comments: '',
                    evento_terapeuta: '',
                },
                client_if_staff2 : false,
                rowSelected3: {
                    person_id: null,
                    category_id: '',
                    room_id : '',
                    therapist_id : '',
                    start_time : '',
                    end_time : '',
                    search_nome : '',
                    search_telefone : '',
                    search_email : '',
                    search_data_nasc : '',
                    search_cod_fiscal: '',
                    search_reserva : '',
                    search_quarto : '',
                    selectedContact : [],
                    event_date : '',
                    event_id : '',
                    event_schedule_id: null,
                    nome : '',
                    email : '',
                    data_nascimento : '',
                    nacionalidade : '',
                    cod_nacionalidade : '',
                    telefone : '',
                    cod_fiscal : '',
                    cod_sexo : '',
                    update_contact : false,
                    comments: '',
                    evento_terapeuta: '',
                },
                client_if_staff3 : false,

                countries: [],

                tempRowSelected: {},
                tempRowSelected2: {},
                tempRowSelected3: {},

                spaEvents: [],
                spaEvents_second: [],
                spaEvents_third: [],
                spaEventsOriginal: [],
                spaEventsOriginal2: [],
                spaEventsOriginal3: [],

                spaTherapists: [],
                spaTherapists2: [],
                spaTherapists3: [],
                spaTherapistsConstant: [],
                spaTherapistsOriginal: [],
                spaTherapistsOriginal2: [],
                spaTherapistsOriginal3: [],

                rooms: [],
                roomsConstant: [],

                clientSearchResult: [],
                clientSearchResult2: [],
                clientSearchResult3: [],

                resources: [],
                resources_original: [],
                events: [],

                backEvents: [],

                scheduler_errors: {
                    'event_id': false,
                    'event_id_second': false,
                    'event_id_third': false,
                    'category_id': false,
                    'room_id': false,
                    'therapist_id': false,
                    'therapist_id_second': false,
                    'therapist_id_third': false,
                    'start_time': false,
                    'start_time_max': false,
                    'start_time_max2': false,
                    'start_time_max3': false,
                    'event_date': false,
                    'nome': false,
                    'nome2': false,
                    'nome3': false,
                    email: false,
                    email2: false,

                    email1: false,
                    email11: false,
                    email12: false,

                    email3: false,
                    email13: false,
                    email23: false,

                    'data_nascimento': false,

                    'nacionalidade': false,
                    'nacionalidade2': false,
                    'nacionalidade3': false,

                    telefone: false,
                    telefone2: false,

                    telefone1: false,
                    telefone12: false,

                    telefone3: false,
                    telefone13: false,

                    cod_fiscal: false,
                    cod_fiscal2: false,

                    cod_fiscal1: false,
                    cod_fiscal12: false,

                    cod_fiscal3: false,
                    cod_fiscal13: false,

                    cod_sexo: false,
                    cod_sexo2: false,
                    cod_sexo3: false,

                    evento_terapeuta: false,
                    evento_terapeuta_second: false,
                    evento_terapeuta_third: false,
                },

                min_time_picker: '',
                spa_close_time : '',

                start_time_max: '',
                start_time_max2: '',
                start_time_max3: '',

                cancelMenuItems: [],

                therapist_allowed: false,

                rowcancel: {
                    id: '',
                    item: '',
                    item2: '',
                },

                display_price: '',
                display_price2: '',
                display_price3: '',
                display_price_n_pax: '',
                display_price_n_pax2: '',
                display_price_n_pax3: '',
                token: '',
                categoriesEventsList: [],
                twoPerson: false,
                twoEvent: false,
                thirdPerson: false,
                thirdEvent: false,
                selectedTab: 0,
                selectedTab2: 0,
                selectedTab3: 0,
                ptBR: ptBR,

                eventos_terapeutas: [],
                eventos_terapeutasOriginal: [],
                clientSelectedOption: {id:1,name:'Cliente 1'},
                clientOptionTab: [
                    {id:1,name:'Cliente 1'}
                ],
                toEditEvents: [],
                argsEvents: [],
                popupDrag: false,
                popupDragType: '',
                popupDragTitle: '',
                popupDragText: '',
                popupDragButton: '',
                extraTime: 2,
                spa_real_open_time: '',
                spa_real_close_time: '',
                reservation_status: {
                    2 : 'Reservado',
                    3 : 'Due in',
                    4 : 'Check-in',
                    5 : 'Due out',
                    6 : 'Check-out',
                }
            }
        },

        components: {
            DayPilotScheduler,
            Datepicker,
            'v-select': vSelect,
            flatPickr,
            FormWizard,
            TabContent,
            VueSimpleSuggest,
        },

        methods: {
            closeTimePicker(){
            },

            hasElevatedPermissions(){
                let current_user_info = JSON.parse(window.localStorage.getItem('userSession'));

                 if( current_user_info.istherapistmanager || current_user_info.isSpaDirector || current_user_info.userType == 7 ){
                    return true;
                 }

                 return false;
            },

            handleScheduleEvent(tr) {
                this.tempRowSelected = JSON.parse(JSON.stringify(tr));

                this.scheduler_errors.nome = false;
                this.scheduler_errors.cod_sexo = false;
                this.scheduler_errors.nacionalidade = false;
                this.scheduler_errors.telefone = false;
                this.scheduler_errors.email = false;

                this.rowSelected.nome = this.tempRowSelected.nome;
                this.rowSelected.telefone = this.tempRowSelected.telefone;
                this.rowSelected.email = this.tempRowSelected.email;
                this.rowSelected.data_nascimento = this.tempRowSelected.data_nascimento;
                this.rowSelected.nacionalidade = this.tempRowSelected.nacionalidade;
                this.rowSelected.cod_nacionalidade = this.tempRowSelected.cod_nacionalidade;
                this.rowSelected.person_id = this.tempRowSelected.cod_pessoa;
                this.rowSelected.cod_fiscal = this.tempRowSelected.cod_fiscal;
                this.rowSelected.cod_sexo = this.tempRowSelected.cod_sexo;
                this.rowSelected.reservation_id = this.tempRowSelected.reservation_id;
                this.rowSelected.reservation_status = this.tempRowSelected.reservation_status;

                if( this.displayEdit ){
                    this.profile_chosen  = true;
                }

                this.setClientsSelectOptions(0,this.rowSelected.nome);

                if(this.tempRowSelected.is_staff == 1){
                    this.client_if_staff = true;
                }else{
                    this.client_if_staff = false;
                }

                this.selectedTab = 1;
                this.rowSelected.search_cod_fiscal = '';
                this.rowSelected.search_data_nasc = '';
                this.rowSelected.search_email = "";
                this.rowSelected.search_nome = "";
                this.rowSelected.search_quarto = '';
                this.rowSelected.search_reserva = '';
                this.rowSelected.search_telefone = '';
                this.clientSearchResult = [];

            },

            handleScheduleEvent2(tr) {
                this.tempRowSelected2 = JSON.parse(JSON.stringify(tr));

                this.scheduler_errors.nome2 = false;
                this.scheduler_errors.cod_sexo2 = false;
                this.scheduler_errors.nacionalidade2 = false;
                this.scheduler_errors.telefone2 = false;
                this.scheduler_errors.email2 = false;

                this.rowSelected2.nome = this.tempRowSelected2.nome;
                this.rowSelected2.telefone = this.tempRowSelected2.telefone;
                this.rowSelected2.email = this.tempRowSelected2.email;
                this.rowSelected2.data_nascimento = this.tempRowSelected2.data_nascimento;
                this.rowSelected2.nacionalidade = this.tempRowSelected2.nacionalidade;
                this.rowSelected2.cod_nacionalidade = this.tempRowSelected2.cod_nacionalidade;
                this.rowSelected2.person_id = this.tempRowSelected2.cod_pessoa;
                this.rowSelected2.cod_fiscal = this.tempRowSelected2.cod_fiscal;
                this.rowSelected2.cod_sexo = this.tempRowSelected2.cod_sexo;
                this.rowSelected2.reservation_id = this.tempRowSelected2.reservation_id;
                this.rowSelected2.reservation_status = this.tempRowSelected2.reservation_status;

                if( this.displayEdit ){
                    this.profile_chosen2  = true;
                }

                this.setClientsSelectOptions(1,this.rowSelected2.nome);

                if(this.tempRowSelected2.is_staff == 1){
                    this.client_if_staff2 = true;
                }else{
                    this.client_if_staff2 = false;
                }

                this.selectedTab2 = 1;
                this.rowSelected2.search_cod_fiscal = '';
                this.rowSelected2.search_data_nasc = '';
                this.rowSelected2.search_email = "";
                this.rowSelected2.search_nome = "";
                this.rowSelected2.search_quarto = '';
                this.rowSelected2.search_reserva = '';
                this.rowSelected2.search_telefone = '';
                this.clientSearchResult2 = [];

            },

            handleScheduleEvent3(tr) {
                this.tempRowSelected3 = JSON.parse(JSON.stringify(tr));

                this.scheduler_errors.nome3 = false;
                this.scheduler_errors.cod_sexo3 = false;
                this.scheduler_errors.nacionalidade3 = false;
                this.scheduler_errors.telefone3 = false;
                this.scheduler_errors.email3 = false;

                this.rowSelected3.nome = this.tempRowSelected3.nome;
                this.rowSelected3.telefone = this.tempRowSelected3.telefone;
                this.rowSelected3.email = this.tempRowSelected3.email;
                this.rowSelected3.data_nascimento = this.tempRowSelected3.data_nascimento;
                this.rowSelected3.nacionalidade = this.tempRowSelected3.nacionalidade;
                this.rowSelected3.cod_nacionalidade = this.tempRowSelected3.cod_nacionalidade;
                this.rowSelected3.person_id = this.tempRowSelected3.cod_pessoa;
                this.rowSelected3.cod_fiscal = this.tempRowSelected3.cod_fiscal;
                this.rowSelected3.cod_sexo = this.tempRowSelected3.cod_sexo;

                if( this.displayEdit ){
                    this.profile_chosen3  = true;
                }

                this.setClientsSelectOptions(2,this.rowSelected3.nome);

                if(this.tempRowSelected3.is_staff == 1){
                    this.client_if_staff3 = true;
                }else{
                    this.client_if_staff3 = false;
                }

                this.selectedTab3 = 1;
                this.rowSelected3.search_cod_fiscal = '';
                this.rowSelected3.search_data_nasc = '';
                this.rowSelected3.search_email = "";
                this.rowSelected3.search_nome = "";
                this.rowSelected3.search_quarto = '';
                this.rowSelected3.search_reserva = '';
                this.rowSelected3.search_telefone = '';
                this.clientSearchResult3 = [];

            },

            checkSameClient(client, cod_pessoa){
                let rowSelected = client < 2 ? 'rowSelected' : 'rowSelected' + client;
                this[rowSelected].person_id;
                return true;
            },

            async loadEvents(currentSpa,date) {
                let that = this;

                if(currentSpa){
                    this.$vs.loading();

                    await axios({
                        method: 'get',
                        url: themeConfig.apiurl + '/spa/events/onSchedule/bySpaDay/' + currentSpa,
                        params: {
                            search: date,
                            token: that.token,
                        }
                    }).then(function (res) {
                        if(res.status == 200){
                            that.events = res.data;
                            Vue.set(that.config, "events", that.events);
                            that.loadBackEvents(currentSpa,date);
                        }
                    }).catch( function (err) {
                        console.log(err);
                        that.$vs.loading.close();
                    }).then(function(){
                    });
                }else{
                    this.notify('Erro - Spa não selecionado', 'red', 10);
                }

            },

            refresh(){
                let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");
                this.loadResources(this.spaInitial);
            },

            async loadResources(currentSpa, date = this.config.startDate.value.substr(0,10) ) {
                let that = this;

                this.$vs.loading();

                return await axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/therapists/bySpaSchedule/' + currentSpa,
                    params: {
                        token: that.token,
                    }
                }).then(function (res) {
                    if(res.status == 200){

                        that.resources_original = res.data;

                        that.spaTherapistsConstant = res.data.filter(el => el.status == 1);

                        if(that.oldCurrentSpa != currentSpa){
                            that.checkifistherapist();
                            that.loadSpaworkingTime(currentSpa);
                            that.loadRoomsSpaTherapists(currentSpa);
                            that.loadCancelMenuItems();
                        }

                        that.filterInactiveTherapist(currentSpa, date);


                        that.oldCurrentSpa = currentSpa;
                    }

                    that.$vs.loading.close();

                }).catch( function (err) {
                    that.notify(err.response.data.message, 'red');
                });
            },

            async filterInactiveTherapist(currentSpa, date = this.config.startDate.value.substr(0,10)){

                await this.loadEvents(currentSpa, date);

                this.resources = [];
                for (let i = 0; i < this.resources_original.length; i++) {
                    if(this.resources_original[i].status == 0){
                        let found = false;
                        for (let j = 0; j < this.events.length; j++) {
                            if(this.resources_original[i].therapist_id == this.events[j].therapist_id){
                                found = true;
                            }
                        }
                        if(found){
                            this.resources.push(this.resources_original[i]);
                        }
                    }else{
                        this.resources.push(this.resources_original[i]);
                    }
                }

                Vue.set(this.config, "resources", this.resources);
            },

            time_lock(){
                if(this.rowSelected.event_date != '' && this.rowSelected.event_date != null &&
                    (
                        (this.rowSelected.event_id != '' && this.rowSelected.event_id != null && this.twoEvent == false) ||
                        (this.rowSelected.event_id != '' && this.rowSelected.event_id != null &&
                        this.rowSelected2.event_id != '' && this.rowSelected2.event_id != null &&
                        this.twoEvent == true)
                    )
                    ){
                    return false;
                }
                return true;
            },

            move_days: function(val) {
                this.config.startDate = this.config.startDate.addDays(val);
                if(this.jumpDate == ''){
                    this.checkCancelar(new Date(this.config.startDate.value));
                }
                this.jumpDate = '';

                let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");

                this.loadEvents(this.spaInitial,date);
            },

            move_today() {
                this.config.startDate = DayPilot.Date.today();
            },

            allowUpdate() {
                this.update = true;
            },

            updateColor: function(event, color) {
                event.data.color = color;
                this.scheduler.events.update(event);
            },

            newEvent() {
                this.title ='Novo Evento';

                this.display_price = '';
                this.display_price2 = '';
                this.display_price3 = '';

                this.display_price_n_pax = '';
                this.display_price_n_pax2 = '';
                this.display_price_n_pax3 = '';

                this.displayNew = true;
                this.displayEdit = false;

                this.spa_id =  this.$store.state.selectedSpa.spa_id;

                this.spa_nome = this.$store.state.selectedSpa.name + ' | ' + this.$store.state.selectedSpa.hvg_nome;

                this.showModal = true;
                this.loadingEdit = false;

                let x = document.getElementById('rowSelected-event_id').getElementsByTagName('input')[0];
                let y = document.getElementById('rowSelected-room_id').getElementsByTagName('input')[0];

                let att =  document.createAttribute("autocomplete");
                let att1 =  document.createAttribute("autocomplete");
                let att2 =  document.createAttribute("autocomplete");
                att.value = "off";
                att1.value = "off";
                att2.value = "off";

                x.setAttributeNode(att);
                y.setAttributeNode(att1);

                if(this.categoriesEventsList.length == 0){
                    this.getSpaEventsCategories();
                }
            },

            async editEvent() {
                this.title = 'Editar Evento';
                this.displayNew = false;
                this.displayEdit = true;
                this.editEventRequest = true;
                this.showModal = true;
                this.loadingEdit = true;
                this.spa_id = this.$store.state.selectedSpa.spa_id;
                this.spa_nome = this.$store.state.selectedSpa.name + ' | ' + this.$store.state.selectedSpa.hvg_nome;
                this.loaded_therapists_events = [];

                this.clientOptionTab = [];

                this.$vs.loading();

                try {
                    // Processa todos os eventos em paralelo
                    await Promise.all(this.toEditEvents.map(async (eventData, i) => {
                        // Define preços e flags
                        if (i == 0) {
                            this.display_price = eventData.event.price;
                            this.display_price_n_pax = eventData.event.event_n_pax;
                            this.rowSelected.event_schedule_id = eventData.event_schedule_id;
                        } else if (i == 1) {
                            this.twoEvent = true;
                            this.twoPerson = true;
                            this.display_price2 = eventData.event.price;
                            this.display_price_n_pax2 = eventData.event.event_n_pax;
                            this.rowSelected2.event_schedule_id = eventData.event_schedule_id;
                        } else if (i == 2) {
                            this.thirdEvent = true;
                            this.thirdPerson = true;
                            this.display_price3 = eventData.event.price;
                            this.display_price_n_pax3 = eventData.event.event_n_pax;
                            this.rowSelected3.event_schedule_id = eventData.event_schedule_id;
                        }

                        // GET CATEGORY LIST
                        const categoryRes = await axios.get(`${themeConfig.apiurl}/spa/category/list?token=${window.localStorage.getItem('usertoken')}`);
                        const rowSelectedIndex = i == 0 ? 'rowSelected' : i == 1 ? 'rowSelected2' : 'rowSelected3';

                        this.categoriesEventsList = categoryRes.data;
                        this[rowSelectedIndex].category_id = {
                            event_category_id: eventData.event.event_category_id,
                            name: eventData.event.event_category.name
                        };

                        // GET EVENT LIST
                        const eventRes = await axios.get(`${themeConfig.apiurl}/spa/events/bySpaSchedule/${this.spaInitial}`, {
                            params: {
                                token: this.token,
                                category_id: this[rowSelectedIndex].category_id.event_category_id
                            }
                        });

                        if (eventRes.status == 200) {
                            // Atualiza lista de eventos
                            if (i == 0) {
                                this.spaTherapists = [];
                                this.spaEvents = eventRes.data;
                                this.spaEventsOriginal = eventRes.data;
                            } else if (i == 1) {
                                this.spaTherapists2 = [];
                                this.spaEvents_second = eventRes.data;
                                this.spaEventsOriginal2 = eventRes.data;
                            } else {
                                this.spaTherapists3 = [];
                                this.spaEvents_third = eventRes.data;
                                this.spaEventsOriginal3 = eventRes.data;
                            }

                            // Set event_id
                            this[rowSelectedIndex].event_id = {
                                event_id: eventData.event.event_id,
                                name: eventData.event.name
                            };

                            // ROOM LIST
                            this.filteringRooms();
                            this[rowSelectedIndex].room_id = {
                                id: eventData.room_id,
                                name: eventData.room.name
                            };

                            // THERAPIST LIST
                            this.spaTherapistsConstant.forEach(el1 => {
                                el1.events.forEach(el2 => {
                                    if (el2.event_id == this[rowSelectedIndex].event_id.event_id) {
                                        const tempTherapist = JSON.parse(JSON.stringify(el1));
                                        if (i == 0) this.spaTherapists.push(tempTherapist);
                                        if (i == 1) this.spaTherapists2.push(tempTherapist);
                                        if (i == 2) this.spaTherapists3.push(tempTherapist);
                                    }
                                });
                            });

                            // Set therapist_id
                            if (i == 0) {
                                this.spaTherapistsOriginal = JSON.parse(JSON.stringify(this.spaTherapists));
                                this.rowSelected.therapist_id = this.spaTherapistsOriginal.find(el => el.id == eventData.therapist_id);
                            } else if (i == 1) {
                                this.spaTherapistsOriginal2 = JSON.parse(JSON.stringify(this.spaTherapists2));
                                this.rowSelected2.therapist_id = this.spaTherapistsOriginal2.find(el => el.id == eventData.therapist_id);
                            } else {
                                this.spaTherapistsOriginal3 = JSON.parse(JSON.stringify(this.spaTherapists3));
                                this.rowSelected3.therapist_id = this.spaTherapistsOriginal3.find(el => el.id == eventData.therapist_id);
                            }

                            // SET DATE
                            this[rowSelectedIndex].event_date = eventData.start_time;

                            // TIME
                            let events_list = [];
                            if (i == 0) { // events list
                                events_list = this.spaEvents;
                            } else if (i == 1) {
                                events_list = this.spaEvents_second;
                            } else {
                                events_list = this.spaEvents_third;
                            }

                            this.configdateTimePicker.maxTime = this.spa_close_time;
                            const indexTemp = events_list.findIndex(item => item.event_id === this[rowSelectedIndex].event_id.event_id);

                            const tmpHourEnd = events_list[indexTemp].duration.substring(0,2);
                            const tmpMinEnd = events_list[indexTemp].duration.substring(3,5);

                            const tmpHourpPep = events_list[indexTemp].preparation_time.substring(0,2);
                            const tmpMinpPep = events_list[indexTemp].preparation_time.substring(3,5);

                            let temp_spa_close_time = DayPilot.Date.today()
                                .addHours(this.configdateTimePicker.maxTime.substring(0,2))
                                .addMinutes(this.configdateTimePicker.maxTime.substring(3,5));

                            temp_spa_close_time = DayPilot.Date(temp_spa_close_time)
                                .addHours(-tmpHourpPep)
                                .addMinutes(-tmpMinpPep);

                            this.start_time_max = DayPilot.Date(temp_spa_close_time)
                                .addHours(-tmpHourEnd - tmpHourpPep)
                                .addMinutes(-tmpMinEnd - tmpMinEnd)
                                .toString("HH:mm");

                            // SET TIME
                            const time = eventData.start_time.substring(11).slice(0, -3);
                            const time2 = eventData.end_time.substring(11).slice(0, -3);
                            this[rowSelectedIndex].start_time = time;
                            this[rowSelectedIndex].end_time = time2;

                            // SET OBSERVATIONS
                            this[rowSelectedIndex].comments = eventData.comments;

                            this.loaded_therapists_events.push({
                                therapist_id: this[rowSelectedIndex].therapist_id.id,
                                event_id: this[rowSelectedIndex].event_id.event_id,
                                label: this[rowSelectedIndex].event_id.name + ' | ' + this[rowSelectedIndex].therapist_id.name,
                            });

                            this.eventos_terapeutas = this.loaded_therapists_events;

                            this[rowSelectedIndex].evento_terapeuta = {
                                therapist_id: this[rowSelectedIndex].therapist_id.id,
                                event_id: this[rowSelectedIndex].event_id.event_id,
                                label: this[rowSelectedIndex].event_id.name + ' | ' + this[rowSelectedIndex].therapist_id.name,
                            };

                            const resCliente = await axios({
                                method: 'get',
                                url: themeConfig.apiurl + '/spa/persons/toSpaSchedule/byId',
                                params: {
                                    token: this.token,
                                    client_ids: [eventData.person_id]
                                }
                            });

                            if (resCliente.status == 200) {
                                resCliente.data.forEach((element) => {
                                    let num = i === 0 ? '' : i + 1;
                                    let staff_key = "client_if_staff" + num;
                                    let profile_chosen_key = "profile_chosen" + num;

                                    let existe = this.clientOptionTab.some(item => item.id === element.cod_pessoa);

                                    if (existe) {
                                        this.clientOptionTab.push({
                                            id: num,
                                            name: "Cliente " + (i + 1)
                                        });
                                        return;
                                    }

                                    this[rowSelectedIndex].nome                 = element.nome;
                                    this[rowSelectedIndex].email                = element.email;
                                    this[rowSelectedIndex].data_nascimento      = element.data_nascimento;
                                    this[rowSelectedIndex].nacionalidade        = element.nacionalidade;
                                    this[rowSelectedIndex].cod_nacionalidade    = element.nationality.cod_pais;
                                    this[rowSelectedIndex].telefone             = element.telefone;
                                    this[rowSelectedIndex].cod_fiscal           = element.cod_fiscal;
                                    this[rowSelectedIndex].cod_sexo             = element.cod_sexo;
                                    this[rowSelectedIndex].selectedContact.card = element.card;
                                    this[rowSelectedIndex].person_id            = element.cod_pessoa;
                                    this[staff_key]                             = element.is_staff;
                                    this[profile_chosen_key]                    = true;

                                    this.clientOptionTab.push({
                                        id: element.cod_pessoa,
                                        name: (i + 1) + ' - ' + element.nome
                                    });

                                    this.clientOptionTab.sort((a, b) => {
                                        return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
                                    });

                                    if( this.clientOptionTab.length > 0 ){
                                        this.clientSelectedOption = this.clientOptionTab[0];
                                    }

                                });
                            }
                        }
                    }));

                    this.editEventRequest = false;
                    this.loadingEdit = false;
                    this.loaded_therapists_events = [];
                    this.$vs.loading.close();

                } catch (err) {
                    console.error(err);
                    this.loaded_therapists_events = [];
                    this.editEventRequest = false;
                    this.displayEdit = false;
                    this.showModal = false;
                    this.loadingEdit = false;
                    this.$vs.loading.close();
                    this.notify('Erro ao carregar os dados.', 'red');
                }
            },

            cancelEvent(args) {
                this.popupDrag = false;

                this.title ='Cancelar Evento';

                let now_time = new DayPilot.Date().toString("yyyy-MM-dd HH:mm");
                let event_end_time = new DayPilot.Date(args.data.end).addMinutes(30).toString("yyyy-MM-dd HH:mm");

                if(now_time >= event_end_time){
                    this.notify('O cancelamento só é permitido até 30 minutos após a hora de término da marcação', 'red');
                }else{
                    this.rowcancel.event_ids = [];
                    this.rowcancel.item = args.data;
                    this.rowcancel.event_ids.push(this.rowcancel.item.id);

                    if(this.toEditEvents.length > 1){
                        for (var i = 0; i < this.toEditEvents.length; i++) {
                            if(this.toEditEvents[i].event_schedule_id != this.rowcancel.item.id){
                                this.rowcancel.event_ids.push(this.toEditEvents[i].event_schedule_id);
                            }
                        }
                    }

                    this.displayNew = false;
                    this.displayEdit = false;

                    this.showModal = false;
                    this.loadingEdit = false;

                    this.showCancelMenu = true;
                }
            },

            getSpaEventsCategories(){
                let that = this;
                this.$vs.loading();
                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/category/list?token='+window.localStorage.getItem('usertoken') ,
                }).then(function (res) {
                    if(res.status == 200){
                        that.categoriesEventsList = res.data;
                    }
                }).catch( function (err) {
                    console.log(err);
                }).then(function (res){
                    that.$vs.loading.close();
                });
            },

            loadCancelMenuItems() {
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/cancel/menu/items',
                    params: {
                        token: that.token,
                    }
                }).then(function (res){
                    if(res.status == 200){
                        that.cancelMenuItems = res.data;
                    }
                }).catch( function (err) {
                    console.log(err);
                });
            },

            closepop(){
                this.displayEdit = false;
                this.displayNew = false;
                this.afterHoursEvent = false;

                this.showModal = false;
                this.loadingEdit = false;

                this.$refs.formwizard.changeTab(1,0);

                this.scheduler_errors.event_id = false;
                this.scheduler_errors.event_id_second = false;
                this.scheduler_errors.category_id = false;
                this.scheduler_errors.room_id = false;
                this.scheduler_errors.therapist_id = false;
                this.scheduler_errors.therapist_id_second = false;
                this.scheduler_errors.event_date = false;
                this.scheduler_errors.start_time = false;
                this.scheduler_errors.start_time_max = false;
                this.scheduler_errors.start_time_max2 = false;
                this.scheduler_errors.start_time_max3 = false;
                this.scheduler_errors.cod_sexo = false;

                this.display_price = '';
                this.display_price2 = '';
                this.display_price3 = '';
                
                this.display_price_n_pax = '';
                this.display_price_n_pax2 = '';
                this.display_price_n_pax3 = '';

                this.rooms = [];

                this.spaTherapists = [];
                this.spaTherapists2 = [];

                this.selectedTab  = 0;
                this.selectedTab2 = 0;
                this.selectedTab3 = 0;

                this.spaEvents = [];
                this.spaEvents_second = [];
                this.spaEvents_third = [];
            },

            closepop2() {
                this.rowcancel.id = '';
                this.rowcancel.item = '';
                this.rowcancel.event_ids = [];
            },

            closepop3() {
                this.popupDrag = false;
                this.loadResources(this.spaInitial);
            },

            closeChargeRoomPopup(){
                this.showChargeRoomPopup = false;
                this.chargeRoomEvent = false;
            },

            closeAfterHoursPopup(){
                this.showAfterHoursPopup = false;
                this.saveAfterHoursEvent(false);
            },

            closePassedEventsPopup(){
                this.showPassedEventsPopup = false;
                this.savePassedEvents(false);
            },

            clearFields(){
                // Object.keys(this.rowSelected).forEach(k => this.rowSelected[k] = '');
                // Object.keys(this.rowSelected2).forEach(k => this.rowSelected2[k] = '');

                this.rowSelected = {
                    person_id: null,
                    category_id: '',
                    room_id : '',
                    therapist_id : '',
                    start_time : '',
                    end_time : '',
                    search_nome : '',
                    search_telefone : '',
                    search_email : '',
                    search_data_nasc : '',
                    search_cod_fiscal: '',
                    search_reserva : '',
                    search_quarto : '',
                    selectedContact : [],
                    event_date : new DayPilot.Date.today().toString("yyyy-MM-dd"),
                    event_id : '',
                    event_schedule_id: null,
                    nome : '',
                    email : '',
                    data_nascimento : '',
                    nacionalidade : '',
                    cod_nacionalidade : '',
                    telefone : '',
                    cod_fiscal : '',
                    cod_sexo : '',
                    update_contact : false,
                    comments: '',
                    evento_terapeuta: '',
                };

                this.rowSelected2 = {
                    person_id: null,
                    category_id: '',
                    room_id : '',
                    therapist_id : '',
                    start_time : '',
                    end_time : '',
                    search_nome : '',
                    search_telefone : '',
                    search_email : '',
                    search_data_nasc : '',
                    search_cod_fiscal: '',
                    search_reserva : '',
                    search_quarto : '',
                    selectedContact : [],
                    event_date : new DayPilot.Date.today().toString("yyyy-MM-dd"),
                    event_id : '',
                    event_schedule_id: null,
                    nome : '',
                    email : '',
                    data_nascimento : '',
                    nacionalidade : '',
                    cod_nacionalidade : '',
                    telefone : '',
                    cod_fiscal : '',
                    cod_sexo : '',
                    update_contact : false,
                    comments: '',
                    evento_terapeuta: '',
                };

                this.rowSelected3 = {
                    person_id: null,
                    category_id: '',
                    room_id : '',
                    therapist_id : '',
                    start_time : '',
                    end_time : '',
                    search_nome : '',
                    search_telefone : '',
                    search_email : '',
                    search_data_nasc : '',
                    search_cod_fiscal: '',
                    search_reserva : '',
                    search_quarto : '',
                    selectedContact : [],
                    event_date : new DayPilot.Date.today().toString("yyyy-MM-dd"),
                    event_id : '',
                    event_schedule_id: null,
                    nome : '',
                    email : '',
                    data_nascimento : '',
                    nacionalidade : '',
                    cod_nacionalidade : '',
                    telefone : '',
                    cod_fiscal : '',
                    cod_sexo : '',
                    update_contact : false,
                    comments: '',
                    evento_terapeuta: '',
                },

                this.showNew = true;
                this.showNew2 = true;
                this.showNew3 = true;

                this.client_if_staff = false;
                this.client_if_staff2 = false;
                this.client_if_staff3 = false;

                this.spaEvents_second = [];
                this.spaEvents_third = [];
                this.spaEventsOriginal = [];
                this.spaEventsOriginal2 = [];
                this.spaEventsOriginal3 = [];

                this.spaTherapists = [];
                this.spaTherapists2 = [];
                this.spaTherapists3 = [];

                this.clientSearchResult = [];
                this.clientSearchResult2 = [];
                this.clientSearchResult3 = [];

                this.scheduler_errors = {
                    'event_id': false,
                    'event_id_second': false,
                    'event_id_third': false,
                    'category_id': false,
                    'room_id': false,
                    'therapist_id': false,
                    'therapist_id_second': false,
                    'therapist_id_third': false,
                    'start_time': false,
                    'start_time_max': false,
                    'start_time_max2': false,
                    'start_time_max3': false,
                    'event_date': false,
                    'nome': false,
                    'nome2': false,
                    'nome3': false,
                    email: false,
                    email2: false,

                    email1: false,
                    email11: false,
                    email12: false,

                    email3: false,
                    email13: false,
                    email23: false,

                    'data_nascimento': false,

                    'nacionalidade': false,
                    'nacionalidade2': false,
                    'nacionalidade3': false,

                    telefone: false,
                    telefone2: false,

                    telefone1: false,
                    telefone12: false,

                    telefone3: false,
                    telefone13: false,

                    cod_fiscal: false,
                    cod_fiscal2: false,

                    cod_fiscal1: false,
                    cod_fiscal12: false,

                    cod_fiscal3: false,
                    cod_fiscal13: false,

                    cod_sexo: false,
                    cod_sexo2: false,
                    cod_sexo3: false,

                    evento_terapeuta: false,
                    evento_terapeuta_second: false,
                    evento_terapeuta_third: false,
                };

                this.display_price = '';
                this.display_price2 = '';
                this.display_price3 = '';
                this.display_price_n_pax = '';
                this.display_price_n_pax2 = '';
                this.display_price_n_pax3 = '';
                this.twoPerson = false;
                this.twoEvent = false;
                this.thirdPerson = false;
                this.thirdEvent = false;
                this.selectedTab = 0;
                this.selectedTab2 = 0;
                this.selectedTab3 = 0;

                this.profile_chosen  = false;
                this.profile_chosen2 = false;
                this.profile_chosen3 = false;

                this.eventos_terapeutas = [];
                this.clientSelectedOption = {id:1,name:'Cliente 1'};
                this.clientOptionTab = [
                    {id:1,name:'Cliente 1'}
                ];

                this.currentTabIndex = 0;
                this.afterHoursEvent = false;
            },

            loadSpaEvents(currentSpa, number){
                this.$vs.loading();
                let that = this;

                let event_category_id = that.rowSelected.category_id.event_category_id;

                if( number == 2 ) {
                    event_category_id = that.rowSelected2.category_id.event_category_id
                }

                if( number == 3 ) {
                    event_category_id = that.rowSelected3.category_id.event_category_id
                }

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/events/bySpaSchedule/' + currentSpa,
                    params: {
                        token: that.token,
                        category_id: event_category_id,
                    }
                }).then(function (res) {
                    if(res.status == 200){

                        if( number == 1 ){
                            that.spaEvents = res.data;
                            that.spaEventsOriginal = res.data;
                        }

                        if( number == 2 ) {
                            that.spaEvents_second = res.data;
                            that.spaEventsOriginal2 = res.data;
                        }

                        if( number == 3 ) {
                            that.spaEvents_third = res.data;
                            that.spaEventsOriginal3 = res.data;
                        }
                    }
                }).catch( function (err) {
                    console.log(err);
                }).then(function(){
                    that.$vs.loading.close();
                });
            },

            loadSpaTherapists(currentSpa){
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/therapists/bySpaSchedule/' + currentSpa,
                    params: {
                        token: that.token,
                    }
                })
                .then(function (res)
                {
                    if(res.status == 200)
                    {
                        that.spaTherapistsConstant = res.data;
                    }
                })
                .catch( function (err) {
                    console.log(err);
                })
            },

            loadSpaworkingTime(currentSpa){
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/schedule/worktime/' + currentSpa,
                    params: {
                        token: that.token,
                    }
                })
                .then(function (res) {
                    if(res.status == 200) {
                        let current_user_info = JSON.parse(window.localStorage.getItem('userSession'));
                        that.spa_real_open_time  = res.data.min_time;
                        that.spa_real_close_time = res.data.max_time;

                        that.configdateTimePicker.minTime = res.data.min_time;
                        that.configdateTimePicker.maxTime = res.data.max_time;
                        that.spa_close_time =  res.data.max_time;

                        that.min_time_picker = res.data.min_time;

                        // Open time
                        let [hours, minutes] = res.data.min_time.split(":").map(Number);

                        hours -= that.extraTime;

                        let new_open_time =
                            String(hours).padStart(2, "0") + ":" +
                            String(minutes).padStart(2, "0");

                        // Close time
                        [hours, minutes] = res.data.max_time.split(":").map(Number);

                        hours += that.extraTime;

                        if( hours >= 24 ){
                            hours = 23;
                            minutes = 59;
                        };

                        let new_close_time =
                            String(hours).padStart(2, "0") + ":" +
                            String(minutes).padStart(2, "0");

                        that.config.businessBeginsHour = new_open_time.split(":")[0];
                        that.config.businessEndsHour   = new_close_time.split(":")[0];

                        if( that.hasElevatedPermissions() ){

                            that.configdateTimePicker.minTime = new_open_time;
                            that.min_time_picker = new_open_time;
                            that.configdateTimePicker.maxTime = new_close_time;
                            that.spa_close_time = new_close_time;

                        }

                        that.scheduler.update();
                    }
                })
                .catch( function (err) {
                    console.log(err);
                })
            },

            loadRoomsSpaTherapists(currentSpa){
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/rooms/bySpaSchedule/' + currentSpa,
                    params: {
                        token: that.token,
                    }
                }).then(function (res) {
                    if(res.status == 200){
                        that.roomsConstant = res.data;
                    }
                }).catch( function (err) {
                    console.log(err);
                });
            },

            async validateStep1() {
                let that = this;
                let current_user_info = JSON.parse(window.localStorage.getItem('userSession'));

                var errors_custom = {};

                // Validação de Evento 2 obrigatório
                if (this.twoEvent && (this.rowSelected2.event_id == null || this.rowSelected2.event_id === '')) {
                    this.notify('Os campos do Evento 2 são de preenchimento obrigatório.', 'red');
                    return false;
                }

                // Validação de Evento 3 obrigatório
                if (this.thirdEvent && (this.rowSelected3.event_id == null || this.rowSelected3.event_id === '')) {
                    this.notify('Os campos do Evento 3 são de preenchimento obrigatório.', 'red');
                    return false;
                }

                // Terapeuta 1 obrigatório quando existem duas ou três pessoas
                if ((this.twoPerson || this.thirdPerson) && (this.rowSelected.therapist_id == null || this.rowSelected.therapist_id === '')) {
                    this.notify('O campo Terapeuta 1 é de preenchimento obrigatório.', 'red');
                    return false;
                }

                // Se houver 2 eventos, terapeutas 1 e 2 passam a ser obrigatórios
                if (this.twoEvent && (this.rowSelected.therapist_id == null || this.rowSelected.therapist_id === '')) {
                    this.notify('O campo Terapeuta 1 é de preenchimento obrigatório.', 'red');
                    this.activatePerson(2);
                    return false;
                }

                // Se houver 3 eventos, terapeutas 1, 2 e 3 passam a ser obrigatórios
                if (this.thirdEvent && (this.rowSelected.therapist_id == null || this.rowSelected.therapist_id === '')) {
                    this.notify('O campo Terapeuta 1 é de preenchimento obrigatório.', 'red');
                    this.activatePerson(3);
                    return false;
                }

                if(that.rowSelected.category_id == '' || that.rowSelected.category_id == null){
                    that.scheduler_errors.category_id = true;
                    errors_custom['category_id'] = "error";
                }else{
                    that.scheduler_errors.category_id = false;
                }

                if(that.rowSelected.event_id == '' || that.rowSelected.event_id == null){
                    that.scheduler_errors.event_id = true;
                    errors_custom['event_id'] = "error";
                }else{
                    that.scheduler_errors.event_id = false;
                }

                if(that.rowSelected.room_id == '' || that.rowSelected.room_id == null){
                    that.scheduler_errors.room_id = true;
                    errors_custom['room_id'] = "error";
                }else{
                    that.scheduler_errors.room_id = false;
                }

                if(that.rowSelected.therapist_id == '' || that.rowSelected.therapist_id == null){
                    that.scheduler_errors.therapist_id = true;
                    errors_custom['therapist_id'] = "error";
                }else{
                    that.scheduler_errors.therapist_id = false;
                }

                if(that.rowSelected2.therapist_id == '' || that.rowSelected2.therapist_id == null){
                    if(that.twoPerson){
                        that.scheduler_errors.therapist_id_second = true;
                        errors_custom['therapist_id_second'] = "error";
                    }
                }else{
                    that.scheduler_errors.therapist_id_second = false;
                }

                if(that.rowSelected3.therapist_id == '' || that.rowSelected3.therapist_id == null){
                    if(that.thirdPerson){
                        that.scheduler_errors.therapist_id_third = true;
                        errors_custom['therapist_id_third'] = "error";
                    }
                }else{
                    that.scheduler_errors.therapist_id_third = false;
                }

                if(that.rowSelected.event_date == '' || that.rowSelected.event_date == null){
                    that.scheduler_errors.event_date = true;
                    errors_custom['event_date'] = "error";
                }else{
                    that.scheduler_errors.event_date = false;
                }

                if(that.rowSelected.start_time == '' || that.rowSelected.start_time == null){
                    that.scheduler_errors.start_time = true;
                    errors_custom['start_time'] = "error";
                }else{
                    that.scheduler_errors.start_time = false;
                }

                let menor = {
                    valor: that.start_time_max,
                    erro: 'start_time_max'
                };

                if (
                    that.twoEvent &&
                    that.start_time_max2 &&
                    that.start_time_max2 < menor.valor
                ) {
                    menor = {
                        valor: that.start_time_max2,
                        erro: 'start_time_max2'
                    };
                }

                if (
                    that.thirdEvent &&
                    that.start_time_max3 &&
                    that.start_time_max3 < menor.valor
                ) {
                    menor = {
                        valor: that.start_time_max3,
                        erro: 'start_time_max3'
                    };
                }

                that.scheduler_errors.start_time_max  = false;
                that.scheduler_errors.start_time_max2 = false;
                that.scheduler_errors.start_time_max3 = false;

                if (
                    that.rowSelected.start_time.length !== 0 &&
                    that.rowSelected.start_time > menor.valor
                ) {
                    that.scheduler_errors[menor.erro] = true;
                    return false;
                }

                this.afterHoursEvent = false;
                this.saveAfterHoursEvent = false;
                if( this.hasElevatedPermissions() ){
                    this.afterHoursEvent =
                        // verificação apos fecho
                        (this.rowSelected.end_time &&
                        this.rowSelected.end_time > this.spa_real_close_time) ||

                        (this.twoEvent &&
                        this.rowSelected2.end_time &&
                        this.rowSelected2.end_time > this.spa_real_close_time) ||

                        (this.thirdEvent &&
                        this.rowSelected3.end_time &&
                        this.rowSelected3.end_time > this.spa_real_close_time) ||
                        // verificação antes abertura
                        (this.rowSelected.start_time &&
                        this.rowSelected.start_time < this.spa_real_open_time)  ||

                        (this.twoEvent &&
                        this.rowSelected2.start_time &&
                        this.rowSelected2.start_time < this.spa_real_open_time) ||

                        (this.thirdEvent &&
                        this.rowSelected3.start_time &&
                        this.rowSelected3.start_time < this.spa_real_open_time);
                }

                if(errors_custom.hasOwnProperty('event_id') ||
                    errors_custom.hasOwnProperty('room_id') ||
                    errors_custom.hasOwnProperty('therapist_id') ||
                    errors_custom.hasOwnProperty('therapist_id_second') ||
                    errors_custom.hasOwnProperty('event_date') ||
                    errors_custom.hasOwnProperty('start_time')
                    ){
                    return Promise.reject();
                }

                this.eventos_terapeutasOriginal = [];
                this.eventos_terapeutasOriginal.push({
                        label: this.rowSelected.event_id.name + ' | ' + this.rowSelected.therapist_id.name,
                        event_id: this.rowSelected.event_id.event_id,
                        therapist_id: this.rowSelected.therapist_id.id,
                    }
                );
                if(this.twoPerson){
                    if(!this.twoEvent){
                        this.eventos_terapeutasOriginal.push({
                                label: this.rowSelected.event_id.name + ' | ' + this.rowSelected2.therapist_id.name,
                                event_id: this.rowSelected.event_id.event_id,
                                therapist_id: this.rowSelected2.therapist_id.id,
                            }
                        );
                    }

                    if(this.twoEvent) {
                        this.eventos_terapeutasOriginal.push({
                                label: this.rowSelected2.event_id.name + ' | ' + this.rowSelected2.therapist_id.name,
                                event_id: this.rowSelected2.event_id.event_id,
                                therapist_id: this.rowSelected2.therapist_id.id,
                            }
                        );
                    }


                }
                if(this.thirdPerson){

                    if(!this.thirdEvent){
                        this.eventos_terapeutasOriginal.push({
                                label: this.rowSelected.event_id.name + ' | ' + this.rowSelected3.therapist_id.name,
                                event_id: this.rowSelected.event_id.event_id,
                                therapist_id: this.rowSelected3.therapist_id.id,
                            }
                        );
                    }

                    if(this.thirdEvent) {
                        this.eventos_terapeutasOriginal.push({
                                label: this.rowSelected3.event_id.name + ' | ' + this.rowSelected3.therapist_id.name,
                                event_id: this.rowSelected3.event_id.event_id,
                                therapist_id: this.rowSelected3.therapist_id.id,
                            }
                        );
                    }
                }

                if(!this.displayEdit){
                    this.eventos_terapeutas = JSON.parse(JSON.stringify(this.eventos_terapeutasOriginal));
                }

                let second_terapist = null;
                let third_terapist = null;

                if(this.twoEvent && !this.twoPerson){
                    second_terapist = this.rowSelected.therapist_id.id;
                }

                if(this.twoPerson){
                    second_terapist = this.rowSelected2.therapist_id.id;
                }

                if(this.thirdEvent && !this.thirdPerson){
                    third_terapist = this.rowSelected.therapist_id.id;
                }

                if(this.thirdPerson){
                    third_terapist = this.rowSelected3.therapist_id.id;
                }

                // Permissão para marcar eventos fora do horário de funcionamento do SPA
                if( this.afterHoursEvent && this.hasElevatedPermissions() ){
                    let after_hours_confirmation = await this.openAfterHoursPopup();

                    if( !after_hours_confirmation ){
                        this.$vs.notify({title:'',text: 'Por favor escolha outro horário de inicio.' ,color:'Red',
                        position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
                        return false;
                    }

                    this.saveAfterHoursEvent = true;
                }

                // Permissão para marcar eventos para datas passadas
                let event_date = new DayPilot.Date(this.rowSelected.event_date).toString("yyyy-MM-dd");
                let today = new DayPilot.Date().toString("yyyy-MM-dd")

                if( this.hasElevatedPermissions && event_date < today ){
                    let passed_event_permission = await this.openPassedEventsPopup();

                    if( !passed_event_permission ){
                        this.$vs.notify({title:'',text: 'Por favor escolha outra data.' ,color:'Red',
                        position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
                        return false;
                    }
                }

                let data = {
                    'spa_id': this.spaInitial,
                    'therapist_id': this.rowSelected.therapist_id.id,
                    'therapist_id_second': second_terapist,
                    'therapist_id_third': third_terapist,
                    'event_schedule_id': this.rowSelected.event_schedule_id,
                    'event_schedule_id_second': this.rowSelected2.event_schedule_id ? this.rowSelected2.event_schedule_id : null,
                    'event_schedule_id_third': this.thirdPerson ? this.rowSelected3.event_schedule_id : null,
                    'event': this.rowSelected.event_id,
                    'event_second': this.rowSelected2.event_id ? this.rowSelected2.event_id : null,
                    'event_third': this.rowSelected3.event_id ? this.rowSelected3.event_id : null,
                    'room_id': this.rowSelected.room_id.id,
                    'start_time': this.rowSelected.start_time,
                    'end_time': this.rowSelected.end_time,
                    'end_time_second': this.twoEvent ? this.rowSelected2.end_time : null,
                    'end_time_third': this.thirdEvent ? this.rowSelected3.end_time : null,
                    'date': event_date,
                    'cod_fiscal': this.rowSelected.cod_fiscal,
                    'twoPerson': this.twoPerson,
                    'twoEvent': this.twoEvent,
                    'thirdPerson': this.thirdPerson,
                    'thirdEvent': this.thirdEvent,
                    'editingEvent' : this.displayEdit,
                    'afterHours': this.saveAfterHoursEvent,
                }

                return new Promise((resolve, reject) => {
                    this.$validator.validateAll("step-1").then(result => {
                        if (result) {
                            that.scheduler_errors.event_id = false;
                            that.scheduler_errors.category_id = false;
                            that.scheduler_errors.room_id = false;
                            that.scheduler_errors.therapist_id = false;
                            that.scheduler_errors.therapist_id_second = false;
                            that.scheduler_errors.event_date = false;
                            that.scheduler_errors.start_time = false;

                            that.scheduler_errors.start_time_max = false;
                            that.scheduler_errors.start_time_max2 = false;
                            that.scheduler_errors.start_time_max3 = false;

                            axios({
                                method: 'get',
                                url: themeConfig.apiurl + '/spa/validate/therapist/roomtime/' + this.spaInitial,
                                params: {
                                    validate: data,
                                    token: that.token,
                                }
                            }).then(function (res) {
                                let currentTabClick = document.querySelectorAll('.new-tabs .vs-tabs--li.activeChild button');
                                if( currentTabClick.length > 0 ){
                                    setTimeout(() => {
                                        currentTabClick[0].click()
                                    }, 100);
                                }
                                that.afterHoursEvent = false;
                                resolve(true);
                            }).catch( function (err) {
                                that.notify(err.response.data.message, 'red');
                                reject();
                            })
                        } else {
                            if(that.rowSelected.event_id.length === 0){
                                that.scheduler_errors.event_id = true;
                            }else{
                                that.scheduler_errors.event_id = false;
                            }
                            if(that.rowSelected.category_id.length === 0){
                                that.scheduler_errors.category_id = true;
                            }else{
                                that.scheduler_errors.category_id = false;
                            }

                            if(that.rowSelected.room_id.length === 0){
                                that.scheduler_errors.room_id = true;
                            }else{
                                that.scheduler_errors.room_id = false;
                            }

                            if(that.rowSelected.therapist_id.length === 0){
                                that.scheduler_errors.therapist_id = true;
                            }else{
                                that.scheduler_errors.therapist_id = false;
                            }

                            if(that.twoPerson){
                                if(that.rowSelected2.therapist_id.length === 0){
                                    that.scheduler_errors.therapist_id_second = true;
                                }else{
                                    that.scheduler_errors.therapist_id_second = false;
                                }
                            }

                            if(that.rowSelected.event_date.length === 0){
                                that.scheduler_errors.event_date = true;
                            }else{
                                that.scheduler_errors.event_date = false;
                            }

                            if(that.rowSelected.start_time.length === 0){
                                that.scheduler_errors.start_time = true;
                            }else{
                                that.scheduler_errors.start_time = false;
                            }

                            reject("correct all values");
                        }
                    });
                });
            },

            validateStep2() {
                let that = this;

                return new Promise((resolve, reject) => {
                    this.$validator.validateAll("step-2").then(result => {
                        let notify = false;
                        if(that.twoPerson){
                            if(that.rowSelected2.evento_terapeuta == null || that.rowSelected2.evento_terapeuta == ''){
                                that.scheduler_errors.evento_terapeuta_second = true;

                                that.clientSelectedOption = that.clientOptionTab[1];
                                that.selectedTab2  = 1;

                                notify = true;
                                reject();
                            }else{
                                that.scheduler_errors.evento_terapeuta_second = false;
                            }

                            if(that.rowSelected.evento_terapeuta == null || that.rowSelected.evento_terapeuta == ''){
                                that.scheduler_errors.evento_terapeuta = true;

                                that.clientSelectedOption = that.clientOptionTab[0];
                                that.selectedTab  = 1;

                                notify = true;
                                reject();
                            }else{
                                that.scheduler_errors.evento_terapeuta = false;
                            }
                        }

                        if(that.thirdPerson){

                            if(that.rowSelected3.evento_terapeuta == null || that.rowSelected3.evento_terapeuta == ''){
                                that.scheduler_errors.evento_terapeuta_third = true;

                                that.clientSelectedOption = that.clientOptionTab[2];
                                that.selectedTab2  = 1;

                                notify = true;
                                reject();
                            }else{
                                that.scheduler_errors.evento_terapeuta_third = false;
                            }

                            if(that.rowSelected2.evento_terapeuta == null || that.rowSelected2.evento_terapeuta == ''){
                                that.scheduler_errors.evento_terapeuta_second = true;

                                that.clientSelectedOption = that.clientOptionTab[1];
                                that.selectedTab2  = 1;

                                notify = true;
                                reject();
                            }else{
                                that.scheduler_errors.evento_terapeuta_second = false;
                            }

                            if(that.rowSelected.evento_terapeuta == null || that.rowSelected.evento_terapeuta == ''){
                                that.scheduler_errors.evento_terapeuta = true;

                                that.clientSelectedOption = that.clientOptionTab[0];
                                that.selectedTab  = 1;

                                notify = true;
                                reject();
                            }else{
                                that.scheduler_errors.evento_terapeuta = false;
                            }
                        }

                        if ( result && that.rowSelected.telefone.length !== 0 || result && that.rowSelected.email.length !== 0 || that.rowSelected.reservation_id != null ) {
                            that.scheduler_errors.nome = false;
                            that.scheduler_errors.email = false;
                            that.scheduler_errors.nacionalidade = false;
                            that.scheduler_errors.telefone = false;
                            that.scheduler_errors.cod_sexo = false;
                            resolve(true);
                        } else {
                            if(that.rowSelected.nome.length === 0)
                            {
                                that.scheduler_errors.nome = true;
                            }else{
                                that.scheduler_errors.nome = false;
                            }

                            if(that.rowSelected.nacionalidade.length === 0)
                            {
                                that.scheduler_errors.nacionalidade = true;
                            }else{
                                that.scheduler_errors.nacionalidade = false;
                            }

                            if(that.rowSelected.telefone.length == 0 && that.rowSelected.email.length == 0 && !that.rowSelected.reservation_id != null )
                            {
                                that.scheduler_errors.telefone = true;
                                that.scheduler_errors.email = true;
                            }else{
                                that.scheduler_errors.telefone = false;
                                that.scheduler_errors.email = false;
                            }

                            if(that.rowSelected.cod_sexo.length == 0)
                            {
                                that.scheduler_errors.cod_sexo = true;
                            }else{
                                that.scheduler_errors.cod_sexo = false;
                            }

                            that.clientSelectedOption = that.clientOptionTab[0];
                            that.selectedTab  = 1;

                            notify = true;
                            reject("correct all values");
                        }

                        if( notify ){
                            that.notify('Existem erros de preenchimento.', 'red');
                        }

                    })
                })
            },

            clearContactFields(){
                this.scheduler_errors.nome = false;
                this.scheduler_errors.email = false;
                this.scheduler_errors.nacionalidade = false;
                this.scheduler_errors.telefone = false;
                this.scheduler_errors.cod_sexo = false;

                return true;
            },

            clearContactErrorFields(){
                // Cliente 1
                this.scheduler_errors.evento_terapeuta = false;
                this.scheduler_errors.nome = false;
                this.scheduler_errors.cod_sexo = false;
                this.scheduler_errors.nacionalidade = false;
                this.scheduler_errors.cod_fiscal = false;
                this.scheduler_errors.cod_fiscal1 = false;
                this.scheduler_errors.telefone = false;
                this.scheduler_errors.telefone1 = false;
                this.scheduler_errors.email = false;
                this.scheduler_errors.email1 = false;
                this.scheduler_errors.email11 = false;

                // Cliente 2
                this.scheduler_errors.evento_terapeuta_second = false;
                this.scheduler_errors.nome2 = false;
                this.scheduler_errors.cod_sexo2 = false;
                this.scheduler_errors.nacionalidade2 = false;
                this.scheduler_errors.cod_fiscal2 = false;
                this.scheduler_errors.cod_fiscal12 = false;
                this.scheduler_errors.telefone2 = false;
                this.scheduler_errors.telefone12 = false;
                this.scheduler_errors.email2 = false;
                this.scheduler_errors.email12 = false;

                // Cliente 3
                this.scheduler_errors.evento_terapeuta_third = false;
                this.scheduler_errors.nome3 = false;
                this.scheduler_errors.cod_sexo3 = false;
                this.scheduler_errors.nacionalidade3 = false;
                this.scheduler_errors.cod_fiscal3 = false;
                this.scheduler_errors.cod_fiscal13 = false;
                this.scheduler_errors.telefone3 = false;
                this.scheduler_errors.telefone13 = false;
                this.scheduler_errors.email3 = false;
                this.scheduler_errors.email13 = false;
            },

            addEventSchedule(){
                this.clearContactErrorFields();

                if(this.displayEdit){
                    this.editEventSchedule();
                    return false;
                }

                let that = this;

                let tempArray = ['nome','telefone','email','data_nascimento','nacionalidade','cod_fiscal','cod_sexo'];

                if(this.client_if_staff == false && tempArray[0] in this.tempRowSelected){
                    this.rowSelected.update_contact = tempArray.some((item, idx) => this.rowSelected[item] !== this.tempRowSelected[item]);
                }else{
                    this.rowSelected.update_contact = false;
                }

                if(this.client_if_staff2 == false && tempArray[0] in this.tempRowSelected2){
                    this.rowSelected2.update_contact = tempArray.some((item, idx) => this.rowSelected2[item] !== this.tempRowSelected2[item]);
                }else{
                    this.rowSelected2.update_contact = false;
                }

                if(this.client_if_staff3 == false && tempArray[0] in this.tempRowSelected3){
                    this.rowSelected3.update_contact = tempArray.some((item, idx) => this.rowSelected3[item] !== this.tempRowSelected3[item]);
                }else{
                    this.rowSelected3.update_contact = false;
                }

                let session = JSON.parse(window.localStorage.getItem('userSession'));

                this.rowSelected.spa_id = this.spa_id;
                this.rowSelected.creation_user_id = session.id;

                this.scheduler_errors.cod_fiscal = false;
                this.scheduler_errors.cod_fiscal1 = false;
                this.scheduler_errors.telefone1 = false;
                this.scheduler_errors.email1 = false;
                this.scheduler_errors.email11 = false;

                if(this.twoEvent){
                    this.rowSelected2.comments = this.rowSelected.comments;
                }

                if(this.thirdEvent){
                    this.rowSelected3.comments = this.rowSelected2.comments;
                }

                if(this.twoEvent && !this.twoPerson){
                    this.rowSelected2.therapist_id                  = this.rowSelected.therapist_id;
                    this.rowSelected.evento_terapeuta = {
                        therapist_id:this.rowSelected.therapist_id.id,
                        event_id:this.rowSelected.event_id.event_id
                    };

                    this.rowSelected2.evento_terapeuta = {
                        therapist_id:this.rowSelected2.therapist_id.id,
                        event_id:this.rowSelected2.event_id.event_id
                    };
                }

                if(this.thirdEvent && !this.thirdPerson){
                    this.rowSelected3.therapist_id    = this.rowSelected.therapist_id;
                    
                    if( this.twoPerson ){

                        this.rowSelected3.start_time = this.rowSelected.end_time;
                        this.rowSelected3.end_time = (() => {
                            let [h1, m1] = this.rowSelected3.start_time.split(':').map(Number);
                            let [h2, m2] = this.rowSelected3.event_id.duration.split(':').map(Number);
                            let total = h1 * 60 + m1 + h2 * 60 + m2;
                            return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
                        })();
                    }

                    this.rowSelected.evento_terapeuta = {
                        therapist_id:this.rowSelected.therapist_id.id,
                        event_id:this.rowSelected.event_id.event_id
                    };

                    this.rowSelected3.evento_terapeuta = {
                        therapist_id:this.rowSelected3.therapist_id.id,
                        event_id:this.rowSelected3.event_id.event_id
                    };
                }

                this.$vs.loading();

                axios({
                    method: 'post',
                    url: themeConfig.apiurl + '/spa/new/schedule/event',
                    data: {
                        scheduleEvent: this.rowSelected,
                        scheduleEvent2: this.rowSelected2,
                        scheduleEvent3: this.rowSelected3,
                        twoPerson: this.twoPerson,
                        twoEvent: this.twoEvent,
                        hotel_id: this.hotelSelected,
                        thirdPerson: this.thirdPerson,
                        thirdEvent: this.thirdEvent,
                        token: that.token,
                    }
                }).then(function (response) {
                    that.scheduler.events.add(response.data);

                    that.displayNew = false;

                    that.showModal = false;

                    that.$refs.formwizard.changeTab(1,0);

                    that.clientSearchResult = [];

                    that.$vs.notify({title:'',text:'Evento criado com sucesso.',color:'#63C0BB',position:'top-center'});

                    that.scheduler_errors.cod_fiscal = false;
                    that.scheduler_errors.cod_fiscal1 = false;
                    that.scheduler_errors.telefone1 = false;
                    that.scheduler_errors.email1 = false;

                    that.selectedTab = 0;
                    that.selectedTab2 = 0;
                    that.selectedTab3 = 0;

                    that.refresh();
                }).catch(function (error) {

                    if( error.response.data.message && error.response.data.error_type ){

                        that.$vs.notify({
                            title:'Erro',
                            text: error.response.data.message,
                            color:'Red',
                            position:'top-center',
                            iconPack: 'feather',
                            icon:'icon-alert-circle',
                            time:4000
                        });

                        that.scheduler_errors[error.response.data.error_type] = true;

                        that.clientSelectedOption = that.clientOptionTab[error.response.data.client_index - 1];
                        that.selectedTab  = error.response.data.client_index;
                    }

                }).then(function() {
                    that.$vs.loading.close();
                });
            },

            editEventSchedule(){
                if(this.twoEvent){
                    this.rowSelected2.comments = this.rowSelected.comments;
                }

                if(this.thirdEvent){
                    this.rowSelected3.comments = this.rowSelected.comments;
                }

                let that = this;
                axios({
                    method: 'post',
                    url: themeConfig.apiurl + '/spa/update/schedule/event',
                    data: {
                        start:                    this.rowSelected.start_time,
                        end:                      this.rowSelected.end_time,
                        event_date:               DayPilot.Date(this.rowSelected.event_date).toString("yyyy-MM-dd"),
                        therapist_id:             this.rowSelected.therapist_id.id,
                        id:                       this.rowSelected.event_schedule_id,
                        event_id:                 this.rowSelected.event_id.event_id,
                        room_id:                  this.rowSelected.room_id.id,
                        comments:                 this.rowSelected.comments,
                        start_second:             this.twoPerson ? this.rowSelected.start_time : null,
                        end_second:               this.twoPerson ? this.rowSelected2.end_time : null,
                        therapist_id_second:      this.twoPerson ? this.rowSelected2.therapist_id.id : null,
                        id_second:                this.twoPerson ? this.rowSelected2.event_schedule_id : null,
                        event_id_second:          this.twoPerson ? this.rowSelected2.event_id.event_id : null,
                        room_id_second:           this.twoPerson ? this.rowSelected.room_id.id : null,
                        comments_second:          this.twoPerson ? this.rowSelected2.comments : null,
                        start_third:              this.thirdPerson ? this.rowSelected.start_time : null,
                        end_third:                this.thirdPerson ? this.rowSelected3.end_time : null,
                        therapist_id_third:       this.thirdPerson ? this.rowSelected3.therapist_id.id : null,
                        id_third:                 this.thirdPerson ? this.rowSelected3.event_schedule_id : null,
                        event_id_third:           this.thirdPerson ? this.rowSelected3.event_id.event_id : null,
                        room_id_third:            this.thirdPerson ? this.rowSelected.room_id.id : null,
                        comments_third:           this.thirdPerson ? this.rowSelected3.comments : null,
                        token:                    this.token,

                        client_name:              this.rowSelected.nome,
                        client_email:             this.rowSelected.email,
                        client_data_nascimento:   this.rowSelected.data_nascimento,
                        client_nacionalidade:     this.rowSelected.nacionalidade,
                        client_cod_nacionalidade: this.rowSelected.cod_nacionalidade,
                        client_telefone:          this.rowSelected.telefone,
                        client_cod_fiscal:        this.rowSelected.cod_fiscal,
                        client_cod_sexo:          this.rowSelected.cod_sexo,
                        client_person_id:         this.rowSelected.person_id,
                        profile_chosen:           this.profile_chosen,

                        client_name2:              this.rowSelected2.nome,
                        client_email2:             this.rowSelected2.email,
                        client_data_nascimento2:   this.rowSelected2.data_nascimento,
                        client_nacionalidade2:     this.rowSelected2.nacionalidade,
                        client_cod_nacionalidade2: this.rowSelected2.cod_nacionalidade,
                        client_telefone2:          this.rowSelected2.telefone,
                        client_cod_fiscal2:        this.rowSelected2.cod_fiscal,
                        client_cod_sexo2:          this.rowSelected2.cod_sexo,
                        client_person_id2:         this.rowSelected2.person_id,
                        profile_chosen2:           this.profile_chosen2,

                        client_name3:              this.rowSelected3.nome,
                        client_email3:             this.rowSelected3.email,
                        client_data_nascimento3:   this.rowSelected3.data_nascimento,
                        client_nacionalidade3:     this.rowSelected3.nacionalidade,
                        client_cod_nacionalidade3: this.rowSelected3.cod_nacionalidade,
                        client_telefone3:          this.rowSelected3.telefone,
                        client_cod_fiscal3:        this.rowSelected3.cod_fiscal,
                        client_cod_sexo3:          this.rowSelected3.cod_sexo,
                        client_person_id3:         this.rowSelected3.person_id,
                        profile_chosen3:           this.profile_chosen3,

                        edit_event:        true
                    }

                }).then(function (response) {
                    that.displayEdit = false;
                    that.showModal = false;

                    that.profile_chosen  = false;
                    that.profile_chosen2 = false;
                    that.profile_chosen3 = false;

                    if(that.twoPerson || that.thirdPerson){
                        that.notify('Eventos modificados.', 'green', 10);
                    }else{
                        that.notify('Evento modificado.', 'green');
                    }

                    that.clearFields();
                    that.closepop();
                    that.loadResources(that.spaInitial);
                }).catch(function (error) {

                    let response_message = error.response && error.response.data && error.response.data.message;
                    let response_data    = error.response && error.response.data && error.response.data.data;
                    let client_iteration = error.response && error.response.data.client_iteration ? error.response.data.client_iteration : 0;

                    response_message ? that.notify(error.response.data.message, 'red', 10) : that.notify('Erro a modificar o evento.', 'red', 10);

                    if( response_data && response_data.length > 0 ){

                        switch(client_iteration){
                            case 0:
                                that.profile_chosen  = false;
                                break;
                            case 1:
                                that.profile_chosen2 = false;
                                break;
                            case 2:
                                that.profile_chosen3 = false;
                                break;
                            default:
                                that.profile_chosen  = false;
                                that.profile_chosen2 = false;
                                that.profile_chosen3 = false;
                                break;

                        }

                        that.getClientReservationInfo(response_data,client_iteration,'');

                        let selected_tab = client_iteration > 1 ? client_iteration : '';
                        that.clientSelectedOption = that.clientOptionTab[ (client_iteration - 1) ];
                        setTimeout(() => {
                            that['selectedTab' + selected_tab] = 0 ;
                        }, 50);
                    }
                }).then(function() {
                });

            },

            cancelEventSchedule(){
                if(this.rowcancel.id == ''){
                    this.notify('Selecione uma opção.', 'red');
                    return false;
                }
                this.$vs.loading();

                let that = this;

                let tmp = JSON.parse(this.rowcancel.id);

                let session = JSON.parse(window.localStorage.getItem('userSession'));
                this.rowSelected.creation_user_id = session.id;
                this.rowSelected.status = tmp;

                axios({
                    method: 'put',
                    url: themeConfig.apiurl + '/spa/cancel/schedule/event/' + this.rowcancel.item.id,
                    data: {
                        scheduleEvent: this.rowSelected,
                        events_to_cancel: this.rowcancel.event_ids,
                        token: that.token,
                    }
                }).then(function (response){
                    if(response.status == 200){
                        that.notify('Evento cancelado com sucesso.', 'green');

                        that.rowcancel.event_ids.forEach(function(eventId) {
                            let tmp_event = that.scheduler.events.find(eventId);
                            that.scheduler.events.remove(tmp_event).queue();
                        });

                        that.showCancelMenu = false;

                        let date_event = DayPilot.Date(that.config.startDate).toString("yyyy-MM-dd");

                        that.loadBackEvents(that.spaInitial,date_event);
                    }
                }).catch(function (error){
                    console.log(error);
                    that.notify('Erro a cancelar evento.', 'red');
                }).then(function (response){
                    that.closepop2();
                });
            },

            generateSurveyforEventSchedule(id, event) {
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/validate/survey/' + id,
                    params: {
                        person: event.data.clientId,
                        token: that.token,
                    }
                }).then(function (response){
                    if(response.status == 200){
                        let routeData = '';
                        if(response.data.survey == null){
                            routeData = that.$router.resolve({
                                name: 'survey2', params: {
                                    data: id,
                                }});
                        }else{
                            routeData = that.$router.resolve({
                                name: 'survey3', params: {
                                    schedule_id: id,
                                    survey_id: response.data.survey.spa_survey_id
                                }});
                        }
                        window.open(routeData.href, '_blank');
                    }
                }).catch(function (error){
                    console.log(error);
                });
            },

            openChargeRoomPopup( event_obj ){
                let reservation_id = event_obj.source.data.reservation_id;
                let schedule_id = event_obj.source.data.id;

                if( !reservation_id ){
                    this.notify('Não existe reserva associada a esta marcação.', 'red');
                    return;
                }

                this.showChargeRoomPopup = true;
                this.chargeRoomEvent = event_obj;
            },

            openAfterHoursPopup(){
                this.showAfterHoursPopup = true;

                return new Promise((resolve) => {
                    this.saveAfterHoursEvent = resolve;
                });
            },

            openPassedEventsPopup(){
                this.showPassedEventsPopup = true;

                return new Promise((resolve) => {
                    this.savePassedEvents = resolve;
                });
            },

            scheduleAfterHours(){
                this.showAfterHoursPopup = false;
                this.saveAfterHoursEvent(true);
            },

            schedulePassedEvents(){
                this.showPassedEventsPopup = false;
                this.savePassedEvents(true);
            },

            chargeRoom(){
                var event_obj = this.chargeRoomEvent;
                let reservation_id = event_obj.source.data.reservation_id;
                let schedule_id = event_obj.source.data.id;

                this.$vs.loading();
                axios({
                    method: 'post',
                    url: themeConfig.apiurl + '/spa/room-charge/' + reservation_id + '/' + schedule_id,
                    params: {
                        token: this.token,
                    }
                }).then( (response) => {
                    if(response.status == 200){
                        this.notify(response.data.message, 'green');
                    }

                    this.showChargeRoomPopup = false;
                    this.$vs.loading.close();
                }).catch( (error) => {
                    if (error.response) {
                        if( error.response.status == 400 ){
                            this.notify(error.response.data.message, 'red');
                        } else {
                            this.notify('Ocorreu um erro no débito ao quarto.', 'red');
                        }
                    }

                    this.showChargeRoomPopup = false;
                    this.$vs.loading.close();
                });
            },

            searchContact(client){
                let rowSelected = client < 2 ? 'rowSelected' : 'rowSelected' + client;

                if( this[rowSelected].search_reserva && this[rowSelected].search_reserva.trim().length != 0 ){
                    this.searchByReservation(client, this[rowSelected]);
                    return true;
                }

                if( this[rowSelected].search_quarto && this[rowSelected].search_quarto.trim().length != 0 ){
                    this.searchByRoom(client, this[rowSelected] );
                    return true;
                }

                if(
                    this[rowSelected].search_nome.length == 0 &&
                    this[rowSelected].search_telefone.length == 0 &&
                    this[rowSelected].search_email.length == 0 &&
                    this[rowSelected].search_data_nasc.length == 0 &&
                    this[rowSelected].search_cod_fiscal.length == 0 &&
                    this[rowSelected].search_reserva.length == 0  &&
                    this[rowSelected].search_quarto == 0 ) {

                    this.$vs.notify({title:'',text:'Por favor preencha os campos para a pesquisa',color:'Red',
                        position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
                        return false;

                }

                if( this[rowSelected].search_nome.length > 0 && this[rowSelected].search_telefone.length == 0 && this[rowSelected].search_email.length == 0
                    && this[rowSelected].search_data_nasc.length == 0 && this[rowSelected].search_cod_fiscal.length == 0 ){

                    this.$vs.notify({title:'',text:'Por favor indique mais 1 campo para a pesquisa',color:'Red',
                        position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
                        return false;

                }

                this.searchContactAxios(client);

            },

            searchByReservation( client, rowSelected ){
                let client_ids = [];
                let reservation_id = [];

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/pos/booking/spa/reservation/' + this.hotelSelected+ '/' + rowSelected.search_reserva.trim(),
                    params: {
                        token: this.token,
                    }
                }).then(( response ) => {
                    if(response.status == 200){

                        response.data.forEach(reservation => {
                            client_ids.push(reservation.client.id);
                            let companions = reservation.companions;
                            if(companions){
                                for (let companion in companions) {
                                    if (!companions.hasOwnProperty(companion)) continue;
                                    client_ids.push(companion);
                                }
                            }

                            if(reservation.reservation){
                                reservation_id.push(reservation.reservation);
                            }
                        });

                        this.getClientReservationInfo(client_ids, client, reservation_id );
                    }
                }).catch(function (error){
                    console.log(error);
                });
            },

            searchByRoom( client, rowSelected ){
                let client_ids = [];
                let reservation_id = [];

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/pos/booking/spa/room/' + this.hotelSelected+ '/' + rowSelected.search_quarto.trim(),
                    params: {
                        token: this.token,
                    }
                }).then( ( response ) => {
                    if(response.status == 200){
                        response.data.forEach(reservation => {
                            client_ids.push(reservation.client.id);
                            let companions = reservation.companions;
                            if(companions){
                                for (let companion in companions) {
                                    if (!companions.hasOwnProperty(companion)) continue;
                                    client_ids.push(companion);
                                }
                            }

                            if(reservation.reservation){
                                reservation_id.push(reservation.reservation);
                            }
                        });

                        this.getClientReservationInfo(client_ids, client, reservation_id );
                    }
                }).catch(function (error){
                    console.log(error);
                });
            },

            searchContactAxios(client) {
                let rowSelected = client < 2 ? 'rowSelected' : 'rowSelected' + client;
                let that = this;

                let obj = {
                    'nome': this[rowSelected].search_nome,
                    'cod_fiscal': this[rowSelected].search_cod_fiscal,
                    'telefone': this[rowSelected].search_telefone,
                    'email': this[rowSelected].search_email,
                    'data_nasc': this[rowSelected].search_data_nasc,
                    'cod_hotel': this.hotelSelected,
                }

                this.$vs.loading();

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/persons/toSpaSchedule/byAll',
                    params: {
                        search: obj,
                        token: that.token,
                    }
                })
                .then(function (response) {
                    if(response.status == 200){
                        let clientSearchResult = client < 2 ? 'clientSearchResult' : 'clientSearchResult' + client;
                        that[clientSearchResult] = response.data;
                    }
                }).catch(function (error){
                    console.log(error.response);
                }).then(function(){
                    that.$vs.loading.close();
                });

            },

            getClientReservationInfo(client_ids, client, reservation_id){
                let that = this;

                if( client_ids.length == 0 ){
                    that.notify('Não foram encontrados resultados para a pesquisa feita', 'red');
                    return;
                }

                this.$vs.loading();

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/persons/toSpaSchedule/byId',
                    params: {
                        token: that.token,
                        client_ids: client_ids,
                        reservation_id: reservation_id,
                    }
                }).then(function (response) {
                    if(response.status == 200){
                        let clientSearchResult = client < 2 ? 'clientSearchResult' : 'clientSearchResult' + client;
                        that[clientSearchResult] = response.data;
                    }
                }).catch(function (error){
                    console.log(error);
                }).then(function(){
                    that.$vs.loading.close();
                });
            },

            formWizardTabChange(){
                this.currentTabIndex = this.$refs.formwizard.slotProps.activeTabIndex;

                if(this.currentTabIndex === 0 && !this.displayEdit ){
                    this.rowSelected.search_nome = '';
                    this.rowSelected.search_telefone = '';
                    this.rowSelected.search_email = '';
                    this.rowSelected.search_data_nasc = '';
                    this.rowSelected.search_cod_fiscal = '';
                    this.rowSelected.selectedContact = [];
                    this.rowSelected2.search_nome = '';
                    this.rowSelected2.search_telefone = '';
                    this.rowSelected2.search_email = '';
                    this.rowSelected2.search_data_nasc = '';
                    this.rowSelected2.search_cod_fiscal = '';
                    this.rowSelected2.selectedContact = [];

                    this.clientSearchResult = [];
                    this.clientSearchResult2 = [];

                    this.tempRowSelected = {};
                    this.tempRowSelected2 = {};
                    this.tempRowSelected3 = {};
                }

                if(this.currentTabIndex === 1 && !this.displayEdit ){
                    this.rowSelected.search_nome = '';
                    this.rowSelected.search_telefone = '';
                    this.rowSelected.search_email = '';
                    this.rowSelected.search_data_nasc = '';
                    this.rowSelected.search_cod_fiscal = '';
                    this.rowSelected.search_quarto = '';
                    this.rowSelected.search_reserva = '';
                    this.rowSelected.selectedContact = [];
                    this.rowSelected2.search_nome = '';
                    this.rowSelected2.search_telefone = '';
                    this.rowSelected2.search_email = '';
                    this.rowSelected2.search_data_nasc = '';
                    this.rowSelected2.search_cod_fiscal = '';
                    this.rowSelected2.search_quarto = '';
                    this.rowSelected2.search_reserva = '';
                    this.rowSelected2.selectedContact = [];

                    this.rowSelected.evento_terapeuta = '';
                    this.rowSelected2.evento_terapeuta = '';
                    this.rowSelected3.evento_terapeuta = '';

                    this.clientSearchResult = [];
                    this.clientSearchResult2 = [];
                    this.clientSearchResult3 = [];

                    this.scheduler_errors.cod_fiscal = false;
                    this.scheduler_errors.cod_fiscal1 = false;
                    this.scheduler_errors.telefone1 = false;
                    this.scheduler_errors.email1 = false;
                    this.scheduler_errors.email11 = false;
                    this.scheduler_errors.cod_fiscal2 = false;
                    this.scheduler_errors.cod_fiscal12 = false;
                    this.scheduler_errors.telefone12 = false;
                    this.scheduler_errors.email12 = false;

                    this.client_if_staff = false;
                    this.client_if_staff2 = false;
                    this.client_if_staff3 = false;

                    this.rowSelected.nome = null;
                    this.rowSelected.cod_sexo = null;
                    this.rowSelected.data_nascimento = null;
                    this.rowSelected.nacionalidade = null;
                    this.rowSelected.cod_fiscal = null;
                    this.rowSelected.telefone = null;
                    this.rowSelected.email = null;
                    this.rowSelected.selectedContact.card = null;

                    this.rowSelected2.nome = null;
                    this.rowSelected2.cod_sexo = null;
                    this.rowSelected2.data_nascimento = null;
                    this.rowSelected2.nacionalidade = null;
                    this.rowSelected2.cod_fiscal = null;
                    this.rowSelected2.telefone = null;
                    this.rowSelected2.email = null;
                    this.rowSelected2.selectedContact.card = null;

                    this.rowSelected3.nome = null;
                    this.rowSelected3.cod_sexo = null;
                    this.rowSelected3.data_nascimento = null;
                    this.rowSelected3.nacionalidade = null;
                    this.rowSelected3.cod_fiscal = null;
                    this.rowSelected3.telefone = null;
                    this.rowSelected3.email = null;
                    this.rowSelected3.selectedContact.card = null;

                    this.clientOptionTab = [{ id: 1, name: 'Cliente 1' }];
                    this.getClientsSelectOptions();

                    this.tempRowSelected = {};
                    this.tempRowSelected2 = {};
                    this.tempRowSelected3 = {};

                }

            },

            newContact(){
                this.showNew = true;

                this.rowSelected = JSON.parse(JSON.stringify(this.rowSelected));

                this.rowSelected.person_id = '';
                this.rowSelected.nome = '';
                this.rowSelected.data_nascimento = '';
                this.rowSelected.morada = '';
                this.rowSelected.codigo_postal = '';
                this.rowSelected.localidade = '';
                this.rowSelected.email = '';
                this.rowSelected.telefone= '';
                this.rowSelected.cod_sexo = '';
            },

            datepickerFormat(date){
                return moment(date).format('YYYY-MM-DD');
            },

            validateInput(){
                if(this.$refs.suggestComponent.textLength === 0)
                {
                    this.rowSelected.nacionalidade = '';
                }
            },

            checkifistherapist() {
                let that = this;

                let user = JSON.parse(window.localStorage.getItem('userSession'));

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/isTherapist',
                    params: {
                        person_id: user.id,
                        token: that.token,
                    },
                })
                .then(function(res){
                    if(res.status == 200){
                        if( res.data !== '' && res.data.schedule_authorization == '0' ){
                            that.therapist_allowed = false;
                        }else if ( res.data !== '' && res.data.schedule_authorization == '1' ){
                            that.therapist_allowed = true;
                        }else if ( res.data == '' && user.userType == 7
                            || res.data == '' && user.userType == 110
                            || res.data == '' && user.userType == 101
                            || res.data == '' && user.userType == 123
                            || res.data == '' && user.userType == 124
                            || res.data == '' && user.userType == 125
                            || res.data == '' && user.userType == 5 ){
                            that.therapist_allowed = true;
                        }else{
                            that.therapist_allowed = false;
                        }
                    }
                })
                .catch( function (err){
                    console.log(err);
                })
                .then(function(){
                });
            },

            loadBackEvents(currentSpa, date = DayPilot.Date.today().toString("yyyy-MM-dd") ) {
                let that = this;

                let data = {
                    'date' : date,
                    'action' : 'non-time',
                };

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/therapist/schedule/events/' + currentSpa,
                    params: {
                        search: data,
                        token: that.token,
                    }
                }).then(function (res) {
                    if(res.status == 200){
                        that.backEvents = res.data;

                        let search_open = DayPilot.Date(date);
                        let search_close = DayPilot.Date(date);

                        that.backEvents.forEach(function(element) {
                            const row = that.scheduler.rows.find(element.resource);

                            if (!row) {
                                return;
                            }

                            const cells = row.cells.forRange(element.start, element.end);

                            if (cells) {
                                cells.addClass("turno");
                            }
                        });
                    }
                })
                .catch( function (err) {
                    console.log(err);
                })
                .then(function(){
                    that.$vs.loading.close();
                });
            },

            getCountries(){
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/profile/countries/bySpaClient',
                    params: {
                        token: that.token,
                    },
                })
                .then(function (res) {
                    if(res.status == 200)
                    {
                        that.countries=res.data;
                    }
                })
                .catch( function (err) {
                    console.log(err);
                })
            },

            viewConsultationCard(event_schedule_id, cod_pessoa){
                this.$vs.loading();
                let that = this;
                this.$api({
                    method: 'get',
                    url: '/spa/schedule/consultationCard',
                    params: {
                        cod_pessoa:         cod_pessoa,
                        event_schedule_id:  event_schedule_id,
                        token:              that.token,
                    },
                })
                .then(function (res) {
                    let routeData = '';
                    if(res.data.consultation_card_id == null){
                        routeData = that.$router.resolve({
                            name: 'consultationCard', params: {
                                event_schedule_id: res.data.event_schedule_id,
                                cod_pessoa: res.data.cod_pessoa
                            }});
                    }else{
                        routeData = that.$router.resolve({
                            name: 'consultationCard', params: {
                                event_schedule_id: res.data.event_schedule_id,
                                cod_pessoa: res.data.cod_pessoa,
                                consultation_card_id: res.data.consultation_card_id
                            }});
                    }
                    window.open(routeData.href, '_blank');
                }) .catch( function (err) {
                    that.notify(err.response.data.message, 'red', 10);
                }).then(function() {
                    that.$vs.loading.close();
                });
            },

            checkCancelar(new_date){
                if(new_date < new Date(new Date().toDateString())){
                    this.config.contextMenu.items[3].disabled = true;
                }else{
                    this.config.contextMenu.items[3].disabled = false;
                }
            },

            removeTherapistFromList(){

                this.spaTherapists = JSON.parse(JSON.stringify(this.spaTherapistsOriginal));

                if( this.twoEvent ) {
                    this.spaTherapists2 = JSON.parse(JSON.stringify(this.spaTherapistsOriginal2));
                } else {
                    this.spaTherapists2 = this.spaTherapists;
                }

                if( this.thirdEvent ) {
                    this.spaTherapists3 = JSON.parse(JSON.stringify(this.spaTherapistsOriginal3));
                } else {
                    this.spaTherapists3 = this.spaTherapists2;
                }

                let selected = [];

                if (this.rowSelected && this.rowSelected.therapist_id && this.rowSelected.therapist_id.id) {
                    selected.push(this.rowSelected.therapist_id.id);
                }
                if (this.rowSelected2 && this.rowSelected2.therapist_id && this.rowSelected2.therapist_id.id) {
                    selected.push(this.rowSelected2.therapist_id.id);
                }
                if (this.rowSelected3 && this.rowSelected3.therapist_id && this.rowSelected3.therapist_id.id) {
                    selected.push(this.rowSelected3.therapist_id.id);
                }

                this.spaTherapists  = this.spaTherapists.filter(t  => !selected.includes(t.id));
                this.spaTherapists2 = this.spaTherapists2.filter(t => !selected.includes(t.id));
                this.spaTherapists3 = this.spaTherapists3.filter(t => !selected.includes(t.id));

            },

            removeEventoTerapeutaFromList() {

                this.eventos_terapeutas = JSON.parse(JSON.stringify(this.eventos_terapeutasOriginal));

                let selectedEvents = [];

                if (this.rowSelected && this.rowSelected.evento_terapeuta && this.rowSelected.evento_terapeuta.event_id) {
                    selectedEvents.push(this.rowSelected.evento_terapeuta.therapist_id);
                }
                if (this.rowSelected2 && this.rowSelected2.evento_terapeuta && this.rowSelected2.evento_terapeuta.event_id) {
                    selectedEvents.push(this.rowSelected2.evento_terapeuta.therapist_id);
                }
                if (this.rowSelected3 && this.rowSelected3.evento_terapeuta && this.rowSelected3.evento_terapeuta.event_id) {
                    selectedEvents.push(this.rowSelected3.evento_terapeuta.therapist_id);
                }

                this.eventos_terapeutas = this.eventos_terapeutas.filter(function(e) {
                    return selectedEvents.indexOf(e.therapist_id) == -1;
                });
            },

            activatePerson( person_number ) {

                switch(person_number){
                    case 2:
                        this.twoPerson = true;
                        break;
                    case 3:
                        this.thirdPerson = true;
                        break;
                    default:
                        break;
                }
                this.getClientsSelectOptions();

            },

            activateEvent( event_number ) {

                switch(event_number){
                    case 2:
                        this.twoEvent = true;
                        this.twoPerson = true;

                        this.rowSelected.room_id = null;
                        this.clearTherapists('all');

                        this.spaTherapists2 = [];
                        break;
                    case 3:
                        this.thirdEvent = true;
                        this.thirdPerson = true;

                        this.rowSelected.room_id = null;
                        this.clearTherapists('all');

                        this.spaTherapists3 = [];
                        break;
                    default:
                        break;
                }
                this.getClientsSelectOptions();

            },

            removeEvent( event_number ) {
                switch(event_number){
                    case 2:

                        this.twoEvent = false;
                        this.scheduler_errors.event_id_second = false;
                        this.rowSelected.room_id = null;

                        this.rowSelected2.category_id = [];
                        this.rowSelected2.event_id = null;

                        this.spaEvents_second = [];
                        this.spaEvents_third = [];

                        this.clearTherapists(2);

                        this.spaTherapists2 = [];

                        break;
                    case 3:

                        this.thirdEvent = false;
                        this.scheduler_errors.event_id_third = false;
                        this.rowSelected.room_id = null;

                        this.rowSelected3.category_id = [];
                        this.rowSelected3.event_id = null;
                        this.rowSelected3.therapist_id = null;

                        this.spaEvents_third = [];

                        this.clearTherapists(3);

                        this.spaTherapists3 = [];

                        break;
                    default:
                        break;
                }

                this.getClientsSelectOptions();

            },

            removePerson( person_number ) {

                switch(person_number){
                    case 2:
                        this.twoPerson = false;
                        this.scheduler_errors.therapist_id_second = false;
                        this.clearTherapists(2);
                        break;
                    case 3:
                        this.thirdPerson = false;
                        this.scheduler_errors.therapist_id_third = false;
                        this.clearTherapists(3);
                        break;
                    default:
                        break;
                }
                this.getClientsSelectOptions();

            },

            getClientsSelectOptions() {
                let clientOptions = [];

                if (this.clientOptionTab.length > 0) {
                    clientOptions = [this.clientOptionTab[0]];
                }

                if (this.twoPerson) {
                    clientOptions.push({ id: 2, name: 'Cliente 2' });
                }

                if (this.thirdPerson) {
                    clientOptions.push({ id: 3, name: 'Cliente 3' });
                }

                this.clientOptionTab = clientOptions;
                this.clientSelectedOption = this.clientOptionTab[0];

            },

            setClientsSelectOptions: function(clientTabIndex, clientTabName){
                this.clientOptionTab[clientTabIndex].name = (clientTabIndex + 1) + ' - ' + clientTabName;
            },

            openPopupDrag(type){
                this.popupDragType = type;
                if(type == 'edit'){
                    this.popupDragTitle = 'Modificar Evento';
                    this.popupDragText = 'Ao modificar este evento vai tambem modificar o outro evento associado.';
                    this.popupDragButton = 'Modificar';
                }else if(type == 'cancel'){
                    this.popupDragTitle = 'Cancelar Evento';
                    this.popupDragText = 'Ao cancelar este evento vai tambem cancelar o outro evento associado.';
                    this.popupDragButton = 'Cancelar';
                }
                this.popupDrag = true;
            },

            async dragTrigger(){

                var number_of_events = this.toEditEvents.length;
                var new_start_time   = DayPilot.Date(this.argsEvents.newStart.value).toString("HH:mm");

                this.popupDrag = false;

                // verificar se a nova terapeuta selecionada faz esse tipo de massagem
                var therapist_does_this_type_event = false;
                this.spaTherapistsConstant.forEach(therapist => {

                    if(therapist.id == this.argsEvents.newResource){

                        therapist.events.forEach(event => {
                            if(event.event_id == this.argsEvents.e.cache.event_id){
                                therapist_does_this_type_event = true;
                            }

                        });

                    }

                });

                if(therapist_does_this_type_event){
                    let that = this;
                    if(number_of_events > 1){
                        that.$vs.loading();
                    }
                    axios({
                        method: 'post',
                        url: themeConfig.apiurl + '/spa/update/schedule/event',
                        data: {
                            start:                  new_start_time,
                            end:                    this.toEditEvents[0].end_time,
                            event_date:             DayPilot.Date(this.argsEvents.newStart.value).toString("yyyy-MM-dd"),
                            therapist_id:           this.toEditEvents[0].therapist_id,
                            id:                     this.toEditEvents[0].event_schedule_id,
                            event_id:               this.toEditEvents[0].event_id,
                            room_id:                this.toEditEvents[0].room_id,
                            comments:               this.argsEvents.e.cache.comments,
                            start_second:           number_of_events >= 2 ? new_start_time : null,
                            end_second:             number_of_events >= 2 ? this.toEditEvents[1].end_time : null,
                            therapist_id_second:    number_of_events >= 2 ? this.toEditEvents[1].therapist_id : null,
                            id_second:              number_of_events >= 2 ? this.toEditEvents[1].event_schedule_id : null,
                            event_id_second:        number_of_events >= 2 ? this.toEditEvents[1].event_id : null,
                            room_id_second:         number_of_events >= 2 ? this.toEditEvents[1].room_id : null,
                            comments_second:        number_of_events >= 2 ? this.argsEvents.e.cache.comments : null,
                            start_third:            number_of_events == 3 ? new_start_time : null,
                            end_third:              number_of_events == 3 ? this.toEditEvents[2].end_time : null,
                            therapist_id_third:     number_of_events == 3 ? this.toEditEvents[2].therapist_id : null,
                            id_third:               number_of_events == 3 ? this.toEditEvents[2].event_schedule_id : null,
                            event_id_third:         number_of_events == 3 ? this.toEditEvents[2].event_id : null,
                            room_id_third:          number_of_events == 3 ? this.toEditEvents[2].room_id : null,
                            comments_third:         number_of_events == 3 ? this.argsEvents.e.cache.comments : null,
                            proceed_moving:         null,
                            edit_event:             false,
                            token:                  that.token,
                        }
                    }).then(function (response) {
                        // this.message("Evento modificado.", { cssClass: "green" });
                        if(number_of_events > 1){
                            that.loadResources(that.spaInitial);
                            that.notify('Eventos modificados.', 'green', 10);
                        }else{
                            that.$vs.loading.close();
                            that.notify('Evento modificado.', 'green');
                        }

                        that.loadResources(that.spaInitial);
                    }).catch(function (error) {
                        that.notify('Erro a modificar o evento.', 'red', 10);
                        that.loadResources(that.spaInitial);
                        return false;
                    }).then(function() {
                    });

                }else{
                    this.notify('A terapeuta selecionada não está disponível para a massagem/tratamento da marcação.', 'red', 10);
                    this.loadResources(this.spaInitial);
                    return false;
                }

            },

            swapByTherapistID(originTherapistID, targetTherapistID) {

                if( this.toEditEvents.length == 1 ){
                    this.toEditEvents[0].therapist_id = originTherapistID;
                    return;
                }

                let originIndex = this.toEditEvents.findIndex(ev => ev.therapist_id === originTherapistID);
                let targetIndex = this.toEditEvents.findIndex(ev => ev.therapist_id === targetTherapistID);

                if (targetIndex == -1 ) return;

                if(originIndex  == -1 ){
                    this.toEditEvents[targetIndex].therapist_id = originTherapistID;
                    return;
                }

                const temp = this.toEditEvents[originIndex].therapist_id;
                this.toEditEvents[originIndex].therapist_id = this.toEditEvents[targetIndex].therapist_id;
                this.toEditEvents[targetIndex].therapist_id = temp;

            },

            async recalculateNewEndTime(newStartTime){
                await Promise.all(
                    this.toEditEvents.map( async (event) => {

                        const eventRes = await axios.get(`${themeConfig.apiurl}/spa/events/bySpaSchedule/${this.spaInitial}`, {
                            params: {
                                token: this.token,
                                category_id: event.event.event_category_id
                            }
                        });

                        if (eventRes.status == 200 ) {

                            let events = eventRes.data;

                            let indexTemp = events.findIndex( item => item.event_id == event.event_id);

                            let tmpHourBegin = newStartTime.substring(0,2);
                            let tmpMinBegin = newStartTime.substring(3,5);

                            let tmpHourEnd = events[indexTemp].duration.substring(0,2);
                            let tmpMinEnd = events[indexTemp].duration.substring(3,5);

                            let tmpHourpPep = events[indexTemp].preparation_time.substring(0,2);
                            let tmpMinpPep = events[indexTemp].preparation_time.substring(3,5);

                            let date = DayPilot.Date.today().getDatePart().addHours(tmpHourBegin).addMinutes(tmpMinBegin);

                            date = DayPilot.Date(date).addHours(tmpHourpPep).addMinutes(tmpMinpPep);
                            date = DayPilot.Date(date).addHours(tmpHourEnd).addMinutes(tmpMinEnd);

                            event.end_time = DayPilot.Date(date).toString("HH:mm");
                        }

                    })
                )
            },

            filteringRooms(){

                let tempRoomsSpas = JSON.parse(JSON.stringify(this.roomsConstant.filter(el => el.status == 1)));

                this.rooms = [];

                // filtrar as salas dependento do event_id selecionado
                tempRoomsSpas.forEach(element => {
                    element.events.forEach(event => {

                        if(event == this.rowSelected.event_id.event_id){
                            let tempRoom = JSON.parse(JSON.stringify(element));
                            this.rooms.push(tempRoom);
                        }
                    });
                });

                // filtrar as salas dependento do event_id2 selecionado
                if(this.twoEvent && this.rowSelected2.event_id != null && this.rowSelected2.event_id != ''){

                    tempRoomsSpas.forEach(element => {
                        element.events.forEach(event => {
                            if(event == this.rowSelected2.event_id.event_id){
                                let tempRoom = JSON.parse(JSON.stringify(element));
                                let room_already_exists = this.rooms.filter( el => el.id == tempRoom.id);

                                if(!room_already_exists){
                                    this.rooms.push(tempRoom);
                                }

                            }
                        });
                    });

                }

                // filtrar as salas dependento do event_id3 selecionado
                if(this.thirdEvent && this.rowSelected3.event_id != null && this.rowSelected3.event_id != ''){

                    tempRoomsSpas.forEach(element => {
                        element.events.forEach(event => {
                            if(event == this.rowSelected3.event_id.event_id){
                                let tempRoom = JSON.parse(JSON.stringify(element));
                                let room_already_exists = this.rooms.filter( el => el.id == tempRoom.id);

                                if(!room_already_exists){
                                    this.rooms.push(tempRoom);
                                }

                            }
                        });
                    });

                }

            },

            clearTherapists( number_therapist ){

                switch( number_therapist ){
                    case 1:
                        this.rowSelected.therapist_id = null;
                    case 2:
                        this.rowSelected2.therapist_id = null;
                        break;
                    case 3:
                        this.rowSelected3.therapist_id = null;
                        break;
                    default:
                        this.rowSelected.therapist_id = null;
                        this.rowSelected2.therapist_id = null;
                        this.rowSelected3.therapist_id = null;
                        break;
                }


            },

            eventOptionsFirst() {
                return this.spaEvents.filter(item => (item.event_type_id != 5));
            },

            eventOptionsSecond() {
                return this.spaEvents_second.filter(item => (item.event_type_id != 5));
            },

            eventOptionsThird() {
                return this.spaEvents_third.filter(item => (item.event_type_id != 5));
            },

        },

        mounted: function() { } ,

        created() {
            this.token = window.localStorage.getItem('usertoken');

            this.getCountries();

            if(this.spaInitial !== 0 && this.spaInitial !== null){
                let current_date = moment(new Date()).format("YYYY-MM-DD");
                this.oldCurrentSpa = null;
                this.loadResources(this.spaInitial, current_date);
            }

            let that = this;

            this.config = {
                locale: "pt-pt",
                cellWidthSpec: "Auto",
                timeHeaders: [{"groupBy":"Day","format":"dddd, d MMMM yyyy"},{"groupBy":"Hour"},{"groupBy":"Cell","format":"mm"}],
                scale: "CellDuration",
                cellDuration: 10,
                cellWidthMin: 30,
                days: 1,
                startDate: DayPilot.Date.today(),
                showNonBusiness: false,
                businessWeekends: true,
                eventHeight: 100,
                businessBeginsHour: '09',
                businessEndsHour: '21',
                timeRangeSelectedHandling: "Enabled",
                borderColor: '#666666',
                cellBackColor: '#ffffff',
                allowEventOverlap: true,

                onEventMove: async function (args) {

                    let now_time = new DayPilot.Date().toString("yyyy-MM-dd HH:mm");
                    let event_start_time = new DayPilot.Date(args.e.cache.start.value).toString("yyyy-MM-dd HH:mm");
                    let new_event_start_time = new DayPilot.Date(args.newStart.value).toString("yyyy-MM-dd HH:mm");
                    let new_event_end_time = new DayPilot.Date(args.newEnd.value).toString("yyyy-MM-dd HH:mm");

                    if((now_time >= event_start_time ) && !that.hasElevatedPermissions() ){
                        that.notify('Não é possivel alterar eventos passados ou a decorrer', 'red');
                        args.preventDefault();
                        return false;
                    }else if((now_time >= new_event_start_time ) && !that.hasElevatedPermissions()){
                        that.notify('Não é possivel mover eventos para o passado', 'red');
                        args.preventDefault();
                        return false;
                    }else{
                        let current_user_info = JSON.parse(window.localStorage.getItem('userSession'));
                        that.saveAfterHoursEvent = false;

                        if( that.hasElevatedPermissions() ){
                            let event_new_start_time = new DayPilot.Date(args.newStart.value).toString("HH:mm");
                            let event_new_end_time = new DayPilot.Date(args.newEnd.value).toString("HH:mm");

                            that.afterHoursEvent =
                                // verificação apos fecho
                                (event_new_end_time &&
                                event_new_end_time > that.spa_real_close_time) ||
                                // verificação antes abertura
                                (event_new_start_time &&
                                event_new_start_time < that.spa_real_open_time);

                                if( that.afterHoursEvent ){
                                    let after_hours_confirmation = await that.openAfterHoursPopup();

                                    if( !after_hours_confirmation ){
                                        that.$vs.notify({title:'',text: 'Por favor escolha outro horário.' ,color:'Red',
                                        position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
                                        that.loadResources(that.spaInitial);
                                        return false;
                                    }

                                    that.saveAfterHoursEvent = true;
                                }
                        }

                        that.$vs.loading();

                        // verificar se existe uma segunda marcação associada a esta
                        axios({
                            method: 'get',
                            url: themeConfig.apiurl + '/spa/get/paralel/event',
                            params: {
                                room_id: args.e.cache.room_id,
                                start_time: args.e.cache.start.value,
                                token: that.token,
                            }
                        }).then( async function (res) {
                            that.toEditEvents = [];
                            that.toEditEvents = res.data;

                            let number_of_events = that.toEditEvents.length;
                            let new_start_time = DayPilot.Date(args.newStart.value).toString("HH:mm");

                            // alterar a nova hora de fim para o array toEditEvents
                            await that.recalculateNewEndTime( new_start_time );

                            // ordenar os eventos consoante o terapeuta
                            that.swapByTherapistID(args.newResource, args.e.cache.therapist_id);

                            let data = {
                                'id':                       that.toEditEvents[0].event_schedule_id,
                                'spa_id':                   that.spaInitial,
                                'date':                     args.e.data.start.toString("yyyy-M-d"),
                                'therapist_id':             that.toEditEvents[0].therapist_id,
                                'event_schedule_id':        that.toEditEvents[0].event_schedule_id,
                                'event':                    that.toEditEvents[0].event_id,
                                'room_id':                  that.toEditEvents[0].room_id,
                                'start_time':               new_event_start_time,
                                'end_time':                 that.toEditEvents[0].end_time,
                                'therapist_id_second':      number_of_events >= 2 ? that.toEditEvents[1].therapist_id : null,
                                'event_schedule_id_second': number_of_events >= 2 ? that.toEditEvents[1].event_schedule_id : null,
                                'event_second':             number_of_events >= 2 ? that.toEditEvents[1].event_id : null,
                                'end_time_second':          number_of_events >= 2 ? that.toEditEvents[1].end_time : null,
                                'therapist_id_third':       number_of_events == 3 ? that.toEditEvents[2].therapist_id : null,
                                'event_schedule_id_third':  number_of_events == 3 ? that.toEditEvents[2].event_schedule_id : null,
                                'event_third':              number_of_events == 3 ? that.toEditEvents[2].event_id : null,
                                'end_time_third':           number_of_events == 3 ? that.toEditEvents[2].end_time : null,
                                'cod_fiscal':               null,
                                'twoPerson':                number_of_events >= 2,
                                'twoEvent':                 number_of_events >= 2,
                                'thirdPerson':              number_of_events == 3,
                                'thirdEvent':               number_of_events == 3,
                                'afterHours':               that.saveAfterHoursEvent,
                            };

                            axios({
                                method: 'get',
                                url: themeConfig.apiurl + '/spa/validate/therapist/roomtime/' + that.spaInitial,
                                params: {
                                    validate: data,
                                    token: that.token,
                                }
                            }).then(function (res) {

                                that.$vs.loading.close();
                                that.argsEvents = args;

                                if(that.toEditEvents.length > 1) {
                                    that.$vs.loading.close();
                                    that.openPopupDrag('edit');
                                } else {
                                    that.dragTrigger(1);
                                }
                                that.saveAfterHoursEvent = false;

                            }).catch( function (err) {
                                console.log(err);
                                that.notify(err.response.data.message, 'red');
                                args.preventDefault();
                                that.$vs.loading.close();
                                that.loadResources(that.spaInitial);
                                that.saveAfterHoursEvent = false;
                                return false;
                            })


                        }).catch(function (error) {
                            console.log(error);
                            that.notify('Error finding second event.', 'red');
                            args.preventDefault();
                            that.$vs.loading.close();
                            that.loadResources(that.spaInitial);
                            that.saveAfterHoursEvent = false;
                            return false;
                        });


                    }

                },

                eventResizeHandling: "Disabled",
                onEventResized: function (args) {
                    // this.message("Event resized: " + args.e.text());
                },

                eventDeleteHandling: "Disabled",

                eventClickHandling: "Disabled",
                onEventClicked: function (args) {
                    // that.title ='Editar Evento';
                    // that.editable = true;
                    // that.update = false;
                    // that.showModal = true;

                    // that.rowSelected = JSON.parse(JSON.stringify(args.e.cache));

                    // that.spa_nome = args.e.cache.spa_nome;

                    // that.rowSelected.event_date = that.rowSelected.start.substring(0, 10);
                    // that.rowSelected.start_time =  that.rowSelected.start.substring(11, 16);
                    // that.rowSelected.end_time =  that.rowSelected.end.substring(11, 16);
                },

                eventHoverHandling: "Bubble",
                bubble: new DayPilot.Bubble({
                    onLoad: function(args) {
                        args.html = "Nome: " + args.source.data.clientName;

                        if( args.source.data.loyalty_card ){
                            args.html += "<br/>" + "Fidelização: " + args.source.data.loyalty_card;
                        }

                        args.html += "<br/>" + "Data: " + args.source.data.start.substring(0, 10) +
                        "<br/>" + "Hora: " + args.source.data.start.substring(11, 16) +
                        " as " + args.source.data.end.substring(11, 16);

                        if(args.source.data.event_type_id === '1'){
                            args.html += "<br/>" + "Tratamento: " + args.source.data.therapyName;
                        }else{
                            args.html += "<br/>" + "Massagem: " + args.source.data.therapyName;
                        }

                        args.html += "<br/>" + "Preço: " + args.source.data.therapyPrice + (args.source.data.therapyPrice == "" ? "" : "€");

                        if(args.source.data.clientRoom != null){
                            args.html += "<br/>" + "Nº Quarto: " + args.source.data.clientRoom;
                        }

                        if(args.source.data.comments !== '' && args.source.data.comments !== undefined){
                            args.html +="<br/>" + "Observações: " + args.source.data.comments;
                        }
                    }
                }),

                onBeforeEventRender: function(args){
                    args.data.barColor = args.data.color;

                    args.data.html = '<br/>' +args.data.clientName;

                    if( args.data.loyalty_card ){
                        args.data.html += '<br/>' + args.data.loyalty_card;
                    }

                    args.data.html += '<br/>' + args.data.therapyName;

                    if(args.data.clientTelefone != null){
                        args.data.html += '<br/>' + args.data.clientTelefone;
                    }else if(args.data.clientTelemovel != null){
                        args.data.html += '<br/>' + args.data.clientTelemovel;
                    }

                    args.data.html += '<br/>' + args.data.start.value.substring(11, 16) + ' - ' + args.data.end.value.substring(11, 16) +
                    '<br/>' + '';

                    args.data.areas = [
                    {
                        top: 6,
                        right: 2,
                        icon: "fa fa-sort-down",
                        visibility: "Visible",
                        action: "ContextMenu",
                        style: "font-size: 12px; background-color: #f9f9f9; border: 1px solid #ccc; padding: 2px 2px 0px 2px; cursor:pointer;"
                    }
                    ];
                },

                onBeforeCellRender: function(args) {
                        args.cell.backColor = themeConfig.themeColors.primary;

                        if (!that.spa_real_open_time || !that.spa_real_close_time) {
                            return;
                        }

                        let date = args.cell.start.toString("yyyy-MM-dd");

                        let open = new DayPilot.Date(`${date}T${that.spa_real_open_time}:00`);
                        let close = new DayPilot.Date(`${date}T${that.spa_real_close_time}:00`);

                        if (args.cell.start < open || args.cell.start >= close) {
                            args.cell.backColor = "#ECDDC5";
                        }
                },

                contextMenu: new DayPilot.Menu({
                    showMenuTitle : false,
                    menuTitle: 'Opções',
                    hideOnMouseOut: true,
                    items: [
                    {
                        text: "Cartão de Consulta",
                        icon: "fa fa-align-center",
                        onClick: function(args){
                            let e = args.source;
                            that.viewConsultationCard(e.data.id, e.data.clientId);
                        }
                    },
                    {
                        text: "Questionário",
                        icon: "fa fa-question",
                        onClick: function(args){
                            let e = args.source;
                            that.generateSurveyforEventSchedule(e.data.id, e);
                        }
                    },
                    {
                        text: "Débito ao Quarto",
                        icon: "fa fa-dollar",
                        onClick: function(args){
                            that.openChargeRoomPopup(args);
                        }
                    },
                    {
                        text: "-"
                    },
                    {
                        text: "Alterar",
                        icon: "fa fa-edit",
                        disabled: false,
                        onClick: function(args) {
                            var e = args.source;

                            let now_time = new DayPilot.Date().toString("yyyy-MM-dd HH:mm");
                            let event_start_time = e.data.start.toString("yyyy-MM-dd HH:mm");

                            if(now_time >= event_start_time){
                                that.notify('Não é possivel alterar eventos passados ou a decorrer', 'red');
                            }else{
                                that.$vs.loading();
                                that.toEditEvents = [];
                                // verificar se existe uma segunda marcação associada a esta
                                axios({
                                    method: 'get',
                                    url: themeConfig.apiurl + '/spa/get/paralel/event',
                                    params: {
                                        room_id: e.data.room_id,
                                        start_time: e.data.start,
                                        token: that.token,
                                    }
                                }).then(function (res) {

                                    that.toEditEvents = res.data;
                                    that.argsEvents = e.data;
                                    that.$vs.loading.close();
                                    that.editEvent(that.toEditEvents.length);
                                }).catch(function (error) {
                                    that.notify('Error finding second event.', 'red');
                                    that.$vs.loading.close();
                                }).then(function() {
                                });
                            }
                        }
                    },
                    {
                        text: "-"
                    },
                    {
                        text: "Cancelar",
                        icon: "fa fa-trash",
                        disabled: false,
                        onClick: function(args) {

                            that.$vs.loading();
                            that.toEditEvents = [];
                            // verificar se existe uma segunda marcação associada a esta
                            axios({
                                method: 'get',
                                url: themeConfig.apiurl + '/spa/get/paralel/event',
                                params: {
                                    room_id: args.source.cache.room_id,
                                    start_time: args.source.cache.start.value,
                                    token: that.token,
                                }
                            }).then(function (res) {

                                that.toEditEvents = res.data;
                                that.argsEvents = args;
                                if(that.toEditEvents.length > 1){
                                    that.$vs.loading.close();
                                    that.openPopupDrag('cancel');
                                }else{
                                    that.$vs.loading.close();
                                    that.cancelEvent(args.source);
                                }

                            }).catch(function (error) {
                                that.notify('Error finding second event.', 'red');
                                args.preventDefault();
                                return false;
                                that.$vs.loading.close();
                            }).then(function() {
                            });
                        }
                    },
                    ],
                }),
            };
        },

        computed: {
            scheduler: function () {
                return this.$refs.scheduler.control;
            },

            calendarDate: function() {
                return this.config.startDate.toString("d MMMM yyyy", "pt-pt");
            },
            spasvg() {
                return this.$store.state.spasvg;
            },
            selectedIndex() {
                if (!this.clientSelectedOption) {
                    return -1;
                }

                this.selectedTab  = 1;
                this.selectedTab2 = 1;
                this.selectedTab3 = 1;

                return this.clientOptionTab.findIndex(
                    c => c.id === this.clientSelectedOption.id
                );
            },
            massageFinalValue() {
                let finalPriceString = '';
                let finalPriceValue = 0.0;
                let moreThanOneEvent = false;

                if( this.display_price && this.display_price != '' ){
                    let n_pax = this.display_price_n_pax && parseInt(this.display_price_n_pax) > 0 ? parseInt(this.display_price_n_pax) : 1;
                    finalPriceString += (parseFloat(this.display_price) / n_pax) + ' €';
                    finalPriceValue += (parseFloat(this.display_price) / n_pax);
                }

                if( this.display_price2 && this.display_price2 != '' ){
                    let n_pax2 = this.display_price_n_pax2 && parseInt(this.display_price_n_pax2) > 0 ? parseInt(this.display_price_n_pax2) : 1;
                    finalPriceString += ' + ' + (parseFloat(this.display_price2) / n_pax2) + ' €';
                    finalPriceValue += (parseFloat(this.display_price2) / n_pax2);
                    moreThanOneEvent = true;
                }

                if( this.display_price3 && this.display_price3 != '' ){
                    let n_pax3 = this.display_price_n_pax3 && parseInt(this.display_price_n_pax3) > 0 ? parseInt(this.display_price_n_pax3) : 1;
                    finalPriceString += ' + ' + (parseFloat(this.display_price3) / n_pax3) + ' €';
                    finalPriceValue += (parseFloat(this.display_price3) / n_pax3);
                    moreThanOneEvent = true;
                }

                return moreThanOneEvent ? finalPriceString + ' = ' + finalPriceValue + ' €' : finalPriceValue + ' €';
            },
            disabledDates(){
                if(this.hasElevatedPermissions()){
                    return {};
                }

                return {
                    to: new Date(Date.now() - 864e5)
                }
            }
        },

        watch: {
            jumpDate: function(new_val, old_val) {
                if(new_val !== ''){
                    this.config.startDate = DayPilot.Date(new_val.toISOString());
                    this.checkCancelar(new_val);
                }else{
                    this.checkCancelar(new Date(this.config.startDate.value));
                }

                let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");

                this.filterInactiveTherapist(this.spaInitial, date);

            },

            showModal(new_val,old_val) {
                if(!new_val){
                    this.clearFields();
                }
            },

            spaSelected(new_val,old_val){
                let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");
                this.loadResources(new_val);
            },

            spaInitial(new_val,old_val){
                let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");
                if(new_val != 0){
                    this.loadResources(new_val);
                }

            },

            'rowSelected.event_id': function(new_val, old_val){
                if(new_val != '' && (this.displayNew || this.displayEdit)){
                    if(new_val == old_val || this.loadingEdit){
                        return false;
                    }
                    let display_priceItem = this.spaEvents.find(el => el.event_id == new_val.event_id);

                    this.display_price = display_priceItem.price;
                    this.display_price_n_pax = display_priceItem.n_pax;

                    let tempTherapistSpas = JSON.parse(JSON.stringify(this.spaTherapistsConstant));

                    this.spaTherapists = [];

                    if(!this.twoEvent){
                        this.spaTherapists2 = [];
                    }

                    if( !this.editEventRequest ){
                        this.rowSelected.room_id = '';
                        this.rowSelected.end_time = '';
                        this.rowSelected.event_date = new DayPilot.Date.today().toString("yyyy-MM-dd");
                        this.rowSelected.start_time = '';
                        this.clearTherapists('all');
                    }


                    this.filteringRooms();

                    tempTherapistSpas.forEach(el1 => {
                        el1.events.forEach(el2 => {
                            if(el2.event_id === this.rowSelected.event_id.event_id){
                                let tempTherapist = JSON.parse(JSON.stringify(el1));
                                this.spaTherapists.push(tempTherapist);
                            }
                        });
                    });
                    if(!this.twoEvent){
                        this.spaTherapists2 = JSON.parse(JSON.stringify(this.spaTherapists));
                    }

                    this.spaTherapistsOriginal = JSON.parse(JSON.stringify(this.spaTherapists));

                    this.configdateTimePicker.maxTime = this.spa_close_time;

                    let indexTemp = this.spaEvents.findIndex( item => item.event_id == this.rowSelected.event_id.event_id);

                    let tmpHourEnd = this.spaEvents[indexTemp].duration.substring(0,2);
                    let tmpMinEnd = this.spaEvents[indexTemp].duration.substring(3,5);

                    let tmpHourpPep = this.spaEvents[indexTemp].preparation_time.substring(0,2);
                    let tmpMinpPep = this.spaEvents[indexTemp].preparation_time.substring(3,5);

                    let temp_spa_close_time = DayPilot.Date.today().addHours(this.configdateTimePicker.maxTime.substring(0,2))
                        .addMinutes(this.configdateTimePicker.maxTime.substring(3,5));  //.toString("HH:mm")

                    //temp_spa_close_time = DayPilot.Date(temp_spa_close_time).addHours(-tmpHourpPep).addMinutes(-tmpMinpPep);

                    this.start_time_max = DayPilot.Date(temp_spa_close_time).addHours(-tmpHourEnd - tmpHourpPep).addMinutes(-tmpMinEnd - tmpMinpPep).toString("HH:mm");

                    this.scheduler_errors.start_time_max = false;

                    if(this.twoEvent){
                       if(this.start_time_max2 > this.start_time_max){
                            this.start_time_max2 = this.start_time_max;
                        }
                    }
                    this.removeTherapistFromList();
                }
            },

            'rowSelected2.event_id': function(new_val, old_val){
                if(new_val != '' && (this.displayNew || this.displayEdit)){
                    if(new_val == old_val || this.loadingEdit){
                        return false;
                    }

                    if( !this.editEventRequest ){
                        this.rowSelected.room_id = '';
                        this.clearTherapists('all');
                        this.rowSelected.end_time = '';
                        this.rowSelected.event_date = new DayPilot.Date.today().toString("yyyy-MM-dd");
                        this.rowSelected.start_time = '';
                    }


                    if(new_val != '' && new_val != null){
                        let display_priceItem = this.spaEvents_second.find(el => el.event_id == new_val.event_id);
                        this.display_price2 = display_priceItem.price;
                        this.display_price_n_pax2 = display_priceItem.n_pax;
                    }

                    // filtrar as salas dependento do primeiro event_id selecionado
                    if(new_val != '' && new_val != null){
                        this.filteringRooms();
                    }

                    this.spaTherapists2 = [];
                    if(new_val != '' && new_val != null){
                        let tempTherapistSpas2 = JSON.parse(JSON.stringify(this.spaTherapistsConstant));
                        tempTherapistSpas2.forEach(el1 => {
                            el1.events.forEach(el2 => {
                                if(el2.event_id === this.rowSelected2.event_id.event_id){
                                    let tempTherapist = JSON.parse(JSON.stringify(el1));
                                    this.spaTherapists2.push(tempTherapist);
                                }
                            });
                        });

                        this.spaTherapistsOriginal2 = JSON.parse(JSON.stringify(this.spaTherapists2));
                    }

                    if(new_val != '' && new_val != null){
                        var indexTemp2 = this.spaEvents_second.findIndex( item => item.event_id == this.rowSelected2.event_id.event_id);

                        var tmpHourEnd2 = this.spaEvents_second[indexTemp2].duration.substring(0,2);
                        var tmpMinEnd2 = this.spaEvents_second[indexTemp2].duration.substring(3,5);

                        var tmpHourpPep2 = this.spaEvents_second[indexTemp2].preparation_time.substring(0,2);
                        var tmpMinpPep2 = this.spaEvents_second[indexTemp2].preparation_time.substring(3,5);

                        var temp_spa_close_time2 = DayPilot.Date.today().addHours(this.configdateTimePicker.maxTime.substring(0,2))
                            .addMinutes(this.configdateTimePicker.maxTime.substring(3,5));  //.toString("HH:mm")

                        this.start_time_max2 = DayPilot.Date(temp_spa_close_time2).addHours(-tmpHourEnd2 - tmpHourpPep2).addMinutes(-tmpMinEnd2 - tmpMinpPep2).toString("HH:mm");

                        this.scheduler_errors.start_time_max2 = false;

                        if(this.start_time_max2 > this.start_time_max){
                            this.start_time_max2 = this.start_time_max;
                        }
                    }
                    this.removeTherapistFromList();
                }
            },

            'rowSelected3.event_id': function(new_val, old_val){
                if(new_val != '' && (this.displayNew || this.displayEdit)){
                    if(new_val == old_val || this.loadingEdit){
                        return false;
                    }

                    if( !this.editEventRequest ){
                        this.rowSelected.room_id = '';
                        this.clearTherapists('all');
                        this.rowSelected.end_time = '';
                        this.rowSelected.event_date = new DayPilot.Date.today().toString("yyyy-MM-dd");
                        this.rowSelected.start_time = '';
                    }


                    if(new_val != '' && new_val != null){
                        let display_priceItem = this.spaEvents_third.find(el => el.event_id == new_val.event_id);
                        this.display_price3 = display_priceItem.price;
                        this.display_price_n_pax3 = display_priceItem.n_pax;
                    }

                    // filtrar as salas dependento do primeiro event_id selecionado
                    if(new_val != '' && new_val != null){
                        this.filteringRooms();
                    }

                    this.spaTherapists3 = [];
                    if(new_val != '' && new_val != null){
                        let tempTherapistSpas3 = JSON.parse(JSON.stringify(this.spaTherapistsConstant));
                        tempTherapistSpas3.forEach(el1 => {
                            el1.events.forEach(el2 => {
                                if(el2.event_id === this.rowSelected3.event_id.event_id){
                                    let tempTherapist = JSON.parse(JSON.stringify(el1));
                                    this.spaTherapists3.push(tempTherapist);
                                }
                            });
                        });

                        this.spaTherapistsOriginal3 = JSON.parse(JSON.stringify(this.spaTherapists3));
                    }

                    if(new_val != '' && new_val != null){
                        let indexTemp3 = this.spaEvents_third.findIndex( item => item.event_id == this.rowSelected3.event_id.event_id);

                        let tmpHourEnd3 = this.spaEvents_third[indexTemp3].duration.substring(0,2);
                        let tmpMinEnd3 = this.spaEvents_third[indexTemp3].duration.substring(3,5);

                        let tmpHourpPep2 = this.spaEvents_third[indexTemp3].preparation_time.substring(0,2);
                        let tmpMinpPep2 = this.spaEvents_third[indexTemp3].preparation_time.substring(3,5);

                        let temp_spa_close_time3 = DayPilot.Date.today().addHours(this.configdateTimePicker.maxTime.substring(0,2))
                            .addMinutes(this.configdateTimePicker.maxTime.substring(3,5));  //.toString("HH:mm")

                        this.start_time_max3 = DayPilot.Date(temp_spa_close_time3).addHours(-tmpHourEnd3 - tmpHourpPep2).addMinutes(-tmpMinEnd3 - tmpMinpPep2).toString("HH:mm");

                        this.scheduler_errors.start_time_max3 = false;

                        if(this.start_time_max3 > this.start_time_max2){
                            this.start_time_max3 = this.start_time_max2;
                        }
                    }

                    this.removeTherapistFromList();
                }
            },

            'rowSelected.category_id': function(new_val, old_val){
                if(new_val == old_val || this.loadingEdit){
                    return false;
                }

                if(this.displayNew || this.displayEdit){
                    this.rowSelected.event_id = '';
                }

                if( !this.editEventRequest ){
                    this.rowSelected.room_id = '';
                    this.clearTherapists('all');
                    this.rowSelected.event_date = new DayPilot.Date.today().toString("yyyy-MM-dd");
                    this.rowSelected.start_time = '';
                }

                this.filteringRooms();
                this.spaTherapists = [];

                this.display_price = '';
                this.display_price_n_pax = '';
                if(new_val != '' && new_val != null){
                    this.loadSpaEvents(this.spaInitial, 1);
                }
            },

            'rowSelected2.category_id': function(new_val, old_val){
                if(new_val == old_val || this.loadingEdit){
                    return false;
                }

                this.rowSelected2.event_id = '';

                if( !this.editEventRequest ){
                    this.rowSelected.room_id = '';
                    this.clearTherapists('all');
                    this.rowSelected.event_date = new DayPilot.Date.today().toString("yyyy-MM-dd");
                    this.rowSelected.start_time = '';
                }
                this.filteringRooms();

                this.spaTherapists2 = [];

                this.display_price2 = '';
                this.display_price_n_pax2 = '';
                if(new_val != '' && new_val != null){
                    this.loadSpaEvents(this.spaInitial, 2);
                }
            },

            'rowSelected3.category_id': function(new_val, old_val){
                if(new_val == old_val || this.loadingEdit){
                    return false;
                }
                this.rowSelected3.event_id = '';

                if( !this.editEventRequest ){
                    this.rowSelected.room_id = '';
                    this.clearTherapists('all');
                    this.rowSelected.event_date = new DayPilot.Date.today().toString("yyyy-MM-dd");
                    this.rowSelected.start_time = '';
                }
                this.filteringRooms();

                this.spaTherapists3 = [];

                this.display_price3 = '';
                this.display_price_n_pax3 = '';
                if(new_val != '' && new_val != null){
                    this.loadSpaEvents(this.spaInitial, 3);
                }
            },

            'rowSelected.start_time': async function(new_val, old_val){
                if(this.rowSelected.start_time !== 'undefined' && new_val !== '' && !this.loadingEdit) {

                    var today = new DayPilot.Date().toString("yyyy-MM-dd");
                    var pick_date = new DayPilot.Date(this.rowSelected.event_date).toString("yyyy-MM-dd");

                    if(today === pick_date){
                        let new_min_time = new DayPilot.Date().toString("HH:mm") > this.configdateTimePicker.minTime ? new DayPilot.Date().toString("HH:mm") : this.configdateTimePicker.minTime;
                        this.configdateTimePicker.minTime = new_min_time;

                        if( this.hasElevatedPermissions() ){
                            this.configdateTimePicker.minTime = this.min_time_picker;
                        }
                        
                    }else{
                        this.configdateTimePicker.minTime = this.min_time_picker;
                    }

                    if( new_val < this.spa_real_open_time ){
                        this.afterHoursEvent = true;
                    }

                    if( this.rowSelected.event_id == '' || this.rowSelected.event_id == null ){
                        return;
                    }

                    var indexTemp = this.spaEventsOriginal.findIndex( item => item.event_id == this.rowSelected.event_id.event_id);

                    if(this.twoEvent){
                        var indexTemp2 = this.spaEventsOriginal2.findIndex( item => item.event_id == this.rowSelected2.event_id.event_id);
                    }

                    if(this.thirdEvent){
                        var indexTemp3 = this.spaEventsOriginal3.findIndex( item => item.event_id == this.rowSelected3.event_id.event_id);
                    }

                    var tmpHourBegin = this.rowSelected.start_time.substring(0,2);
                    var tmpMinBegin = this.rowSelected.start_time.substring(3,5);

                    var tmpHourEnd = this.spaEventsOriginal[indexTemp].duration.substring(0,2);
                    var tmpMinEnd = this.spaEventsOriginal[indexTemp].duration.substring(3,5);

                    if(this.twoEvent){
                        var tmpHourEnd2 = this.spaEventsOriginal2[indexTemp2].duration.substring(0,2);
                        var tmpMinEnd2 = this.spaEventsOriginal2[indexTemp2].duration.substring(3,5);
                    }

                    if(this.thirdEvent){
                        var tmpHourEnd3 = this.spaEventsOriginal3[indexTemp3].duration.substring(0,2);
                        var tmpMinEnd3 = this.spaEventsOriginal3[indexTemp3].duration.substring(3,5);
                    }

                    var tmpHourpPep = this.spaEventsOriginal[indexTemp].preparation_time.substring(0,2);
                    var tmpMinpPep = this.spaEventsOriginal[indexTemp].preparation_time.substring(3,5);

                    if(this.twoEvent){
                        var tmpHourpPep2 = this.spaEventsOriginal2[indexTemp2].preparation_time.substring(0,2);
                        var tmpMinpPep2 = this.spaEventsOriginal2[indexTemp2].preparation_time.substring(3,5);
                    }

                    if(this.thirdEvent){
                        var tmpHourpPep3 = this.spaEventsOriginal3[indexTemp3].preparation_time.substring(0,2);
                        var tmpMinpPep3 = this.spaEventsOriginal3[indexTemp3].preparation_time.substring(3,5);
                    }

                    var date = DayPilot.Date.today().getDatePart().addHours(tmpHourBegin).addMinutes(tmpMinBegin);

                    date = DayPilot.Date(date).addHours(tmpHourpPep).addMinutes(tmpMinpPep);
                    date = DayPilot.Date(date).addHours(tmpHourEnd).addMinutes(tmpMinEnd);

                    this.rowSelected.end_time = DayPilot.Date(date).toString("HH:mm");

                    if(this.twoEvent){
                        var date2 = DayPilot.Date.today().getDatePart().addHours(tmpHourBegin).addMinutes(tmpMinBegin);

                        date2 = DayPilot.Date(date2).addHours(tmpHourpPep2).addMinutes(tmpMinpPep2);
                        date2 = DayPilot.Date(date2).addHours(tmpHourEnd2).addMinutes(tmpMinEnd2);

                        this.rowSelected2.start_time = this.rowSelected.start_time;
                        this.rowSelected2.end_time = DayPilot.Date(date2).toString("HH:mm");

                        if( !this.twoPerson ){
                            this.rowSelected2.start_time = this.rowSelected.end_time;

                            date2 = DayPilot.Date(date).addHours(tmpHourEnd2).addMinutes(tmpMinEnd2)
                            this.rowSelected2.end_time = DayPilot.Date(date2).toString("HH:mm");
                        }
                    }

                    if(this.thirdEvent){
                        var date3 = DayPilot.Date.today().getDatePart().addHours(tmpHourBegin).addMinutes(tmpMinBegin);

                        date3 = DayPilot.Date(date3).addHours(tmpHourpPep3).addMinutes(tmpMinpPep3);
                        date3 = DayPilot.Date(date3).addHours(tmpHourEnd3).addMinutes(tmpMinEnd3);

                        this.rowSelected3.start_time = this.rowSelected.start_time;
                        this.rowSelected3.end_time = DayPilot.Date(date3).toString("HH:mm");

                        if( !this.twoPerson && !this.thirdPerson ){
                            this.rowSelected3.start_time = this.rowSelected2.end_time;
                            this.rowSelected3.end_time = DayPilot.Date(date2).addHours(tmpHourEnd3).addMinutes(tmpMinEnd3).toString("HH:mm");
                        }
                    }
                }
            },

            'rowSelected.event_date' : async function(new_val,old_val){
                if(this.rowSelected.event_date !== 'undefined' && new_val !== '' && new_val !== old_val && !this.loadingEdit){
                    let permission_passed_events = false;
                    var today = new DayPilot.Date().toString("yyyy-MM-dd");
                    var pick_date = new DayPilot.Date(new_val).toString("yyyy-MM-dd");

                    if( this.hasElevatedPermissions() && pick_date < today ){
                        let permission_passed_events = true;
                    }

                    if(permission_passed_events){
                        return false;
                    }

                    if(today === pick_date){
                        this.configdateTimePicker.minTime = new DayPilot.Date().toString("HH:mm");
                        this.rowSelected.start_time = new DayPilot.Date().toString("HH:mm");
                    }else{
                        this.configdateTimePicker.minTime = this.min_time_picker;
                    }
                }
            },
            'rowSelected.therapist_id': function(new_val,old_val){
                if(new_val == old_val){
                    return false;
                }
                this.removeTherapistFromList();
            },
            'rowSelected2.therapist_id': function(new_val,old_val){
                if(new_val == old_val){
                    return false;
                }
                this.removeTherapistFromList();
            },
            'rowSelected3.therapist_id': function(new_val,old_val){
                if(new_val == old_val){
                    return false;
                }
                this.removeTherapistFromList();
            },
            'rowSelected.evento_terapeuta': function(new_val,old_val){
                this.removeEventoTerapeutaFromList();
            },
            'rowSelected2.evento_terapeuta': function(new_val,old_val){
                this.removeEventoTerapeutaFromList();
            },
            'rowSelected3.evento_terapeuta': function(new_val,old_val){
                this.removeEventoTerapeutaFromList();
            }
        }
    }
</script>

<style>

.con-vs-popup .vs-popup {
    max-width: calc(100vw - 30px);
    max-height: calc(100vh - 30px);
}

.con-vs-popup .vs-popup .wizard-card-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.con-vs-popup .vs-popup .wizard-card-footer .wizard-footer-left {
    width: 100%;
}

.con-vs-popup .vs-popup .wizard-card-footer .wizard-footer-right {
    width: 100%;
    text-align: right;
}

#popup-marcacoes .vs-popup--content {
    overflow: hidden;
}

#popup-marcacoes .wizard-tab-content {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 285px);
}

#popup-marcacoes .wizard-tab-container {
    overflow: auto;
}

#popup-marcacoes .wizard-tab-container[id^="Cliente"] > form > div {
    padding-top: 50px;
}

#popup-marcacoes .wizard-tab-container[id^="Cliente"] > form > div:first-of-type {
    padding-top: 0px;
    padding-bottom: 15px;
    position: fixed;
    width: calc(100% - 120px) !important;
    background-color: #ffffff;
    z-index: 1000;
}

#popup-marcacoes .wizard-tab-container[id^="Cliente"] > form > div .con-ul-tabs {
    position: fixed;
    margin-bottom: 15px;
    width: calc(100% - 150px);
    z-index: 999;
    background-color: #ffffff;
}

#popup-marcacoes .wizard-tab-container[id^="Cliente"] > form > div .con-slot-tabs {
    margin-top: 30px;
}

#popup-marcacoes .wizard-tab-container[id^="Cliente"] > form > div .con-ul-tabs > ul {
    width: 100%;
    padding-left: 0;
    -webkit-box-shadow: 0 6px 5px -3px rgba(0, 0, 0, .04);
    box-shadow: 0 6px 5px -3px rgba(0, 0, 0, .04);
}


.legenda {
    padding-left: 25px;
}

.scheduler_errors{
    font-size: 15px;
    color: red;

}

.turno{
    background-color: #FFF !important;
}

.red.scheduler_default_message {
    color: #ffffff; background: #FF5252 !important;
}

.green.scheduler_default_message {
    color: #ffffff; background: #4CAF50 !important;
}

#rowSelected-evento_terapeuta{
    width: 100% !important;
}

#rowSelected2-evento_terapeuta{
    width: 100% !important;
}

.vdp-datepicker__calendar .cell.highlighted{
    background: #ECDDC5 !important;
}

.calendar_date{
    z-index: 999999 !important;
}

.new-tabs .line-vs-tabs {
    height: 4px !important;
}

.new-tabs .vs-tabs-primary .con-ul-tabs .activeChild button,
.new-tabs .vs-tabs-primary .con-ul-tabs button:not(:disabled):hover {
    font-weight: 600;
}

@media only screen and (max-width: 600px) {

    h3 {
        font-size: 12px;
        text-align: center;
        padding-top: 8px;
    }

    .second-select {
        margin-left: 0% !important;
    }

    .vdp-datepicker input{
        font-size: .85rem;
        width: 65%;
    }

    .vdp-datepicker__calendar{
        width: 200px !important;
        z-index: 999999 !important ;
    }

    .vdp-datepicker__calendar .month, .vdp-datepicker__calendar .year{
        width: 50%;
    }

    .vs-button{
        font-size: .75rem;
    }
    .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
        padding: 5px 5px;
        margin-bottom: 5px;
    }

    .vs-col{
        padding: 0 5px;

    }

    .custom1{
        display: -webkit-inline-box !important;
    }

    .bt1_back{
        width: 30px !important;
        height: 30px !important;
    }

}
</style>

<style scoped>
    @media only screen and (max-width: 600px) {
        .selectWidth360{
            min-width: 100%;
        }
    }
</style>